import React, { useState, useEffect, useRef, useMemo } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "../StockEntry/StockEntry.css";
import InputField from "./InputField";
import StoneDetailsModal from "./TagStoneDetailsModal";
import PurchaseStoneDetailsModal from "./PurchaseStoneDetailsModal";
import { useNavigate } from "react-router-dom";
import { AiOutlinePlus } from "react-icons/ai";
import baseURL from "../../../../Url/NodeBaseURL";
import "./TagEntry.css";
import { Form, Row, Col, Table } from "react-bootstrap";
import * as XLSX from "xlsx";
import {
  FaCamera,
  FaUpload,
  FaTrash,
  FaEdit,
  FaFileExcel,
  FaEye,
} from "react-icons/fa";
import { Modal, Button, Dropdown, DropdownButton } from "react-bootstrap"; // Add this import
import { jsPDF } from "jspdf";
import QRCode from "qrcode";
import Webcam from "react-webcam";

const getTaxPercentFromSlab = (taxSlab) => {
  if (!taxSlab) return "";
  const numeric = parseFloat(
    typeof taxSlab === "string" ? taxSlab.replace(",", ".") : taxSlab
  );
  return Number.isFinite(numeric) ? numeric.toString() : "";
};

const allowedOpeningTagFields = [
  "tag_id",
  "product_id",
  "account_name",
  "invoice",
  "Pricing",
  "cut",
  "color",
  "clarity",
  "subcategory_id",
  "sub_category",
  "design_master",
  "Prefix",
  "category",
  "Purity",
  "metal_type",
  "PCode_BarCode",
  "Gross_Weight",
  "Stones_Weight",
  "deduct_st_Wt",
  "Stones_Price",
  "WastageWeight",
  "HUID_No",
  "Wastage_On",
  "Wastage_Percentage",
  "Weight_BW",
  "MC_Per_Gram",
  "MP_Per_Gram",
  "Making_Charges_On",
  "TotalWeight_AW",
  "Making_Charges",
  "Status",
  "Source",
  "Stock_Point",
  "pieace_cost",
  "product_Name",
  "making_on",
  "selling_price",
  "dropdown",
  "qr_status",
  "productImage",
  "stone_price_per_carat",
  "pur_rate_cut",
  "pur_Purity",
  "pur_purityPercentage",
  "pur_Gross_Weight",
  "pur_Stones_Weight",
  "pur_deduct_st_Wt",
  "pur_stone_price_per_carat",
  "pur_Stones_Price",
  "pur_Weight_BW",
  "pur_Making_Charges_On",
  "pur_MC_Per_Gram",
  "pur_Making_Charges",
  "pur_Wastage_On",
  "pur_Wastage_Percentage",
  "pur_WastageWeight",
  "pur_TotalWeight_AW",
  "size",
  "tag_weight",
  "pcs",
  "rem_pcs",
  "image",
  "tax_percent",
  "mrp_price",
  "total_pcs_cost",
  "printing_purity",
];

const buildOpeningTagPayload = (source, overrides = {}) => {
  const payload = {};
  allowedOpeningTagFields.forEach((field) => {
    if (Object.prototype.hasOwnProperty.call(overrides, field)) {
      payload[field] = overrides[field];
    } else if (Object.prototype.hasOwnProperty.call(source, field)) {
      payload[field] = source[field];
    }
  });
  return payload;
};

const formatToThreeDecimals = (value) => {
  const num = parseFloat(value);
  if (!Number.isFinite(num)) return "0.000";
  return num.toFixed(3);
};

const TagEntry = ({
  handleCloseTagModal,
  selectedProduct,
  fetchBalance,
  subData,
}) => {
  const [isCameraOpen, setIsCameraOpen] = useState(false);
  const [productDetails, setProductDetails] = useState({
    pcs: selectedProduct?.pcs || 0,
    gross_weight: selectedProduct?.gross_weight || 0,
  });
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const webcamRef = useRef(null);
  const [subCategories, setSubCategories] = useState([]);
  const [productOptions, setProductOptions] = useState([]);
  const [purityOptions, setPurityOptions] = useState([]);
  const [showWebcam, setShowWebcam] = useState(false);
  const [image, setImage] = useState(null);
  const [formData, setFormData] = useState({
    tag_id: selectedProduct.tag_id,
    product_id: selectedProduct.product_id,
    account_name: selectedProduct.account_name,
    category: selectedProduct.category,
    invoice: selectedProduct.invoice,
    sub_category: "",
    subcategory_id: "",
    // subcategory_id: "SBI001",
    product_Name: "",
    design_master: "",
    Pricing: selectedProduct.Pricing,
    cut: "",
    clarity: "",
    color: "",
    Tag_ID: "",
    Prefix: "", // Default value
    // Category: selectedProduct.metal_type,
    Purity: "",
    metal_type: selectedProduct.metal_type,
    PCode_BarCode: "",
    Gross_Weight: "",
    Stones_Weight: "",
    deduct_st_Wt: "Yes",
    stone_price_per_carat: "",
    Stones_Price: "",
    HUID_No: "",
    Wastage_On: "Gross Weight",
    Wastage_Percentage: "",
    Status: "Available",
    Source: "Purchase",
    Stock_Point: "Display Floor1",
    pieace_cost: selectedProduct.rate,
    tax_percent: getTaxPercentFromSlab(selectedProduct?.tax_slab),
    mrp_price: "",
    mrp_per_pcs: "",
    total_pcs_cost: "",
    WastageWeight: "",
    TotalWeight_AW: "",
    MC_Per_Gram: "",
    MP_Per_Gram:"",
    MP_amount:"",
    Making_Charges_On: "",
    Making_Charges: "",
    Design_Master: selectedProduct.design_name,
    Weight_BW: "",
    pur_Gross_Weight: "",
    pur_rate_cut: "",
    pur_Purity: "",
    pur_purityPercentage: "",
    pur_Stones_Weight: "",
    pur_deduct_st_Wt: "Yes",
    pur_stone_price_per_carat: "",
    pur_Stones_Price: "",
    pur_Weight_BW: "",
    pur_Making_Charges_On: "",
    pur_MC_Per_Gram: "",
    pur_Making_Charges: "",
    pur_Wastage_On: "Gross Weight",
    pur_Wastage_Percentage: "",
    pur_WastageWeight: "",
    pur_TotalWeight_AW: "",
    size: "",
    tag_weight: "",
    pcs: "1",
    rem_pcs:"1",
    MC_Per_Gram_Label: "",
    printing_purity: "",
    rate_24k:"",
    rate:selectedProduct.rate,
    selling_addon_purity: "",
    selling_addon_mc_percent: "",
    selling_addon_wastage_percent: "",
  });
  
  // Log formData after initialization
  useEffect(() => {
  }, []);
  
  const [saveLoader, setSaveLoader] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false); // moved up so effects can use
  useEffect(() => {
    if (isEditMode) return;
    if (Array.isArray(subData) && subData.length > 0) {
      const firstSub = subData[0];
      setFormData((prev) => ({
        ...prev,
        sub_category: firstSub.product_name ?? "",
        Purity: firstSub.selling_purity ?? "",
        Wastage_Percentage: firstSub.va_percent ?? "",
        MC_Per_Gram: firstSub.mc_per_gram ?? "",
        printing_purity: firstSub.printing_purity ?? "",
        pur_MC_Per_Gram: firstSub.purchase_mc_percent ?? "",
        pur_Wastage_Percentage: firstSub.purchase_wastage_percent ?? "",
        pur_Purity: firstSub.pur_Purity ?? "",
        selling_addon_purity: firstSub.selling_addon_purity ?? "",
      }));
    }
  }, [subData, isEditMode]);

  const [show, setShow] = useState(false);
  const [showPurchase, setShowPurchase] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleView = (item) => {
    setSelectedRow(item);
    setShowViewModal(true);
  };

  const handleCloseViewModal = () => {
    setShowViewModal(false);
    setSelectedRow(null);
  };

  const [stoneDetails, setStoneDetails] = useState({
    stoneName: "",
    cut: "",
    color: "",
    clarity: "",
    stoneWt: "",
    caratWt: "",
    stonePrice: "",
    amount: "",
  });

  const [stoneList, setStoneList] = useState([]);
  const [editingStoneIndex, setEditingStoneIndex] = useState(null);

  const handleAddStone = () => {
    let newStoneList = [...stoneList];

    if (editingStoneIndex !== null) {
      newStoneList[editingStoneIndex] = stoneDetails;
      setEditingStoneIndex(null);
    } else {
      newStoneList.push(stoneDetails);
    }

    setStoneList(newStoneList);
    localStorage.setItem("tagStoneDetails", JSON.stringify(newStoneList));
    window.dispatchEvent(new Event("storage"));
    setStoneDetails({
      stoneName: "",
      cut: "",
      color: "",
      clarity: "",
      stoneWt: "",
      caratWt: "",
      stonePrice: "",
      amount: "",
    });
  };
  useEffect(() => {
      const fetchCurrentRates = async () => {
        try {
          const response = await axios.get(`${baseURL}/get/current-rates`);
          const fetchedRates = {
            rate_24crt: response.data.rate_24crt || "",
            rate_22crt: response.data.rate_22crt || "",
            rate_18crt: response.data.rate_18crt || "",
            rate_16crt: response.data.rate_16crt || "",
            silver_rate: response.data.silver_rate || "",
          };
          setRates(fetchedRates);
          const sub = formData.category || "";
          const firstWord = sub.split(" ")[0]?.toLowerCase() || "";

          const newRate24k = firstWord === "silver" ? response.data.silver_rate : response.data.rate_24crt;

          setFormData((prev) => ({
            ...prev,
            rate_24k: newRate24k,
          }));
        } catch (error) {
          console.error("Error fetching current rates:", error);
        }
      };
  
      fetchCurrentRates();
    }, [formData.category]);

  const handleEditStone = (index) => {
    const selectedStone = stoneList[index];
    setStoneDetails(selectedStone);
    setEditingStoneIndex(index);
    handleShow();
  };

  const handleDeleteStone = (index) => {
    const updatedList = stoneList.filter((_, i) => i !== index);
    setStoneList(updatedList);
    localStorage.setItem("tagStoneDetails", JSON.stringify(updatedList));
    window.dispatchEvent(new Event("storage"));
  };

  const handleShowPurchase = () => {
    setShowPurchase(true);
  };

  const handleClosePurchase = () => setShowPurchase(false);

  const [purStoneDetails, setPurStoneDetails] = useState({
    stoneName: "",
    cut: "",
    color: "",
    clarity: "",
    stoneWt: "",
    caratWt: "",
    stonePrice: "",
    amount: "",
  });
  const [purchaseStoneList, setPurchaseStoneList] = useState([]);
  const [editingPurchaseStoneIndex, setEditingPurchaseStoneIndex] =
    useState(null);

  const handleAddTagPurStone = () => {
    let newPurchaseStoneList = [...purchaseStoneList];

    if (editingPurchaseStoneIndex !== null) {
      newPurchaseStoneList[editingPurchaseStoneIndex] = purStoneDetails;
      setEditingPurchaseStoneIndex(null);
    } else {
      newPurchaseStoneList.push(purStoneDetails);
    }

    setPurchaseStoneList(newPurchaseStoneList);
    localStorage.setItem(
      "tagPurStoneDetails",
      JSON.stringify(newPurchaseStoneList)
    );
    window.dispatchEvent(new Event("storage"));
    setPurStoneDetails({
      stoneName: "",
      cut: "",
      color: "",
      clarity: "",
      stoneWt: "",
      caratWt: "",
      stonePrice: "",
      amount: "",
    });
  };

  const handleTagPurEditStone = (index) => {
    const selectedStone = purchaseStoneList[index];
    setPurStoneDetails(selectedStone);
    setEditingPurchaseStoneIndex(index);
    handleShowPurchase();
  };

  const handleTagPurDeleteStone = (index) => {
    const updatedList = purchaseStoneList.filter((_, i) => i !== index);
    setPurchaseStoneList(updatedList);
    localStorage.setItem("tagPurStoneDetails", JSON.stringify(updatedList));
    window.dispatchEvent(new Event("storage"));
  };

  const [isGeneratePDF, setIsGeneratePDF] = useState(true);
  const [showModal, setShowModal] = useState(false);
  //const handleOpenModal = () => setShowModal(true);
  const parseNumericValue = (value) => {
    if (value === null || value === undefined) return null;
    const numeric = parseFloat(
      typeof value === "string" ? value.toString().replace(/[^\d.]/g, "") : value
    );
    return Number.isFinite(numeric) ? numeric : null;
  };
  
  // Move these functions after formData is available - they will be defined as functions that can be called later
  const resolveManualPurchasePurity = () => {
    const manualFromForm = formData.pur_purityPercentage;
    const manualFromSelected =
      selectedProduct?.pur_purityPercentage ||
      selectedProduct?.purityPercentage ||
      "";
    return manualFromForm || manualFromSelected || "";
  };

  const resolvePurchasePurityValue = () => {
    const rawFormValue = formData.pur_Purity;
    const rawSelectedValue =
      selectedProduct?.pur_Purity ||
      selectedProduct?.purity ||
      selectedProduct?.pur_purity ||
      "";
    let rawValue = rawFormValue || rawSelectedValue || "";

    const manualPercentage = resolveManualPurchasePurity();

    const isManual =
      rawValue &&
      typeof rawValue === "string" &&
      rawValue.toLowerCase().includes("manual");

    if ((isManual || !rawValue) && manualPercentage) {
      return "Manual";
    }

    return rawValue;
  };

  // Use useMemo to calculate these values after formData is available
  const manualPurchasePurityValue = useMemo(() => {
    const manualFromForm = formData.pur_purityPercentage;
    const manualFromSelected =
      selectedProduct?.pur_purityPercentage ||
      selectedProduct?.purityPercentage ||
      "";
    return manualFromForm || manualFromSelected || "";
  }, [
    formData.pur_purityPercentage,
    selectedProduct?.pur_purityPercentage,
    selectedProduct?.purityPercentage
  ]);
  
  const manualPurchasePurityLabel = useMemo(() => 
    manualPurchasePurityValue && String(manualPurchasePurityValue).trim() !== ""
      ? manualPurchasePurityValue
      : "Manual",
    [manualPurchasePurityValue]
  );
  
  const isByFixed = useMemo(
    () => formData.Pricing?.toLowerCase().trim() === "by fixed",
    [formData.Pricing]
  );

  const isByRunningTag = useMemo(
    () => formData.Pricing?.toLowerCase().trim() === "by running tag",
    [formData.Pricing]
  );

  // Calculate display selling purity: custom_purity (if available) or calculate from components
  const calculateDisplaySellingPurity = () => {
    // Find the selected subcategory once for use throughout the function
    const selectedSubCategory = subCategories.find(
      (cat) => cat.sub_category_name === formData?.sub_category
    );
    
    // Check if custom_purity is available from selectedProduct or subcategory
    if (selectedProduct?.custom_purity) {
      return selectedProduct.custom_purity;
    }
    
    // Also check formData for custom_purity (might be set from subcategory)
    if (formData?.custom_purity) {
      return formData.custom_purity;
    }
    
    // Check subCategories array for the currently selected subcategory's custom_purity
    if (selectedSubCategory?.custom_purity) {
      return selectedSubCategory.custom_purity;
    }
    
    // Otherwise, calculate: purity + purchase_wastage_percent + purchase_mc_percent + selling_addon_purity
    const parsePercent = (val) => {
      if (val === null || val === undefined || val === "") return 0;
      const s = val.toString().replace("%", "").trim();
      const n = Number(s);
      return Number.isFinite(n) ? n : 0;
    };
    
    // Get base purity - prioritize formData (set from selectedProduct in handleEdit) or selectedProduct (purchase record)
    // Note: selectedProduct.purityPercentage is the purchase manual purity from Purchase table
    // When editing, formData.pur_purityPercentage should be set from selectedProduct in handleEdit
    // Also check formData.pur_Purity which might contain the purchase purity value
    let basePuritySource = manualPurchasePurityValue;
    
    if (!basePuritySource) {
      // Check if pur_Purity is "Manual", then use pur_purityPercentage
      if (formData?.pur_Purity && String(formData.pur_Purity).toLowerCase().includes("manual")) {
        basePuritySource = formData?.pur_purityPercentage || "";
      } else if (formData?.pur_Purity) {
        // If pur_Purity is not "Manual", parse it directly (e.g., "91.6%", "22KT")
        basePuritySource = formData.pur_Purity;
      } else {
        // Fallback to other sources
        basePuritySource = formData?.pur_purityPercentage ||
      selectedProduct?.purityPercentage ||  // Purchase table field
          selectedProduct?.Purity || // Purchase purity value
      selectedProduct?.purchase_manual_purity || 
      selectedProduct?.pur_purityPercentage ||
          formData?.purityPercentage || // Also check purityPercentage (might be stored this way in tag)
      (Array.isArray(subData) && subData[0]?.purchase_manual_purity) ||
      (!Array.isArray(subData) && subData?.purchase_manual_purity) ||
      "";
      }
    }
    
    const basePurity = parsePercent(basePuritySource);
    
    // Get purchase wastage - prioritize formData (set from selectedProduct in handleEdit) or selectedProduct (purchase record)
    // Note: selectedProduct.wastage is the purchase wastage from Purchase table
    // When editing, formData.pur_Wastage_Percentage should be set from selectedProduct in handleEdit
    const purchaseWastageSource = formData?.pur_Wastage_Percentage || // formData set from selectedProduct in handleEdit - PRIORITY
      selectedProduct?.wastage ||  // Purchase table field
      selectedProduct?.purchase_wastage_percent || 
      selectedProduct?.pur_Wastage_Percentage || 
      (Array.isArray(subData) && subData[0]?.purchase_wastage_percent) ||
      (!Array.isArray(subData) && subData?.purchase_wastage_percent) ||
      "";
    const purchaseWastage = parsePercent(purchaseWastageSource);
    
    // Get MC (Making Charges) - only if MC On is "MC %"
    // For selling purity calculation, we use PURCHASE MC, not selling MC
    let mcValue = 0;
    // Check purchase MC On first (pur_Making_Charges_On), then fallback to selling MC On
    const mcOn = formData?.pur_Making_Charges_On || 
      formData?.Making_Charges_On || 
      selectedProduct?.pur_Making_Charges_On ||
      selectedProduct?.Making_Charges_On ||
      (Array.isArray(subData) && subData[0]?.mc_on) ||
      (!Array.isArray(subData) && subData?.mc_on) ||
      "";
    console.log("mcOn:", mcOn);
    
    if (mcOn === "MC %" || mcOn?.includes("MC%")) {
      // Get PURCHASE MC percentage (not selling MC) for selling purity calculation
      // Priority: formData.pur_MC_Per_Gram (set from selectedProduct in handleEdit) > selectedProduct.Making_Charges_Value > subData
      // When editing, formData.pur_MC_Per_Gram should be set from selectedProduct in handleEdit
      const mcSource = formData?.pur_MC_Per_Gram || // formData set from selectedProduct in handleEdit - PRIORITY
        selectedProduct?.Making_Charges_Value || // Purchase table field
        (Array.isArray(subData) && subData[0]?.purchase_mc_percent) ||
        (!Array.isArray(subData) && subData?.purchase_mc_percent) ||
        0;
      mcValue = parsePercent(mcSource);
    }
    
    // Get addon purity - check formData first, then selected subcategory, then subData (array)
    // Also check subCategories array for the currently selected subcategory
    const addonPuritySource = formData?.selling_addon_purity ||
      selectedSubCategory?.selling_addon_purity ||
      selectedProduct?.selling_addon_purity || 
      (Array.isArray(subData) && subData[0]?.selling_addon_purity) ||
      (!Array.isArray(subData) && subData?.selling_addon_purity) ||
      "";
    const addonPurity = parsePercent(addonPuritySource);
    
    // Get selling addon MC% - check formData first, then selected subcategory, then subData
    const addonMCSource = formData?.selling_addon_mc_percent ||
      selectedSubCategory?.selling_addon_mc_percent ||
      selectedProduct?.selling_addon_mc_percent || 
      (Array.isArray(subData) && subData[0]?.selling_addon_mc_percent) ||
      (!Array.isArray(subData) && subData?.selling_addon_mc_percent) ||
      "";
    const addonMC = parsePercent(addonMCSource);
    
    // Get selling addon wastage% - check formData first, then selected subcategory, then subData
    const addonWastageSource = formData?.selling_addon_wastage_percent ||
      selectedSubCategory?.selling_addon_wastage_percent ||
      selectedProduct?.selling_addon_wastage_percent || 
      (Array.isArray(subData) && subData[0]?.selling_addon_wastage_percent) ||
      (!Array.isArray(subData) && subData?.selling_addon_wastage_percent) ||
      "";
    const addonWastage = parsePercent(addonWastageSource);
    
    // Total = Purchase Purity + Purchase MC + Purchase Wastage + Selling Add On Purity + Selling Add On MC + Selling Add On Wastage
    const totalPurity = basePurity + mcValue + purchaseWastage + addonPurity + addonMC + addonWastage;
    const result = totalPurity > 0 ? totalPurity.toFixed(2) : null;
    return result;
  };
  
  const displaySellingPurity = useMemo(() => {
    // Only show selling purity if subcategory is selected
    const hasSubCategory = formData?.sub_category && formData.sub_category.trim() !== "";
    if (!hasSubCategory) {
      return "";
    }

    // For "By Running Tag" or when Purity is empty/cleared, always recalculate from components
    const isRunningTag = formData?.Pricing === "By Running Tag";
    const purityIsEmpty = !formData?.Purity || formData.Purity.trim() === "";
    
    // Always recalculate selling purity from components when:
    // 1. It's "By Running Tag" pricing, OR
    // 2. Purity field is empty (like when we clear it during edit), OR
    // 3. We're in edit mode (to ensure fresh calculation), OR
    // 4. We want to ensure correct calculation
    if (isRunningTag || purityIsEmpty || isEditMode) {
      const calculatedPurity = calculateDisplaySellingPurity();
      if (calculatedPurity) {
        return calculatedPurity;
      }
    }
    
    // Fallback to formData.Purity only if it's not "By Running Tag" and calculation fails
    if (!isRunningTag && formData.Purity) {
    return formData.Purity;
    }
    
    return "";
  }, [
    formData?.Purity,
    formData?.Pricing,
    formData?.sub_category,
    formData?.custom_purity,
    formData?.pur_purityPercentage,
    formData?.pur_Wastage_Percentage,
    formData?.pur_MC_Per_Gram,
    formData?.selling_addon_purity,
    formData?.selling_addon_mc_percent,
    formData?.selling_addon_wastage_percent,
    formData?.Making_Charges_On,
    formData?.MC_Per_Gram,
    formData?.pur_Making_Charges_On,
    isEditMode,
    selectedProduct,
    subData,
    subCategories
  ]);
  useEffect(() => {
    // If there is a valid purity from backend (e.g., 40)
    if (manualPurchasePurityValue) {
      // And the select doesn't already match it
      if (formData.pur_Purity !== manualPurchasePurityValue) {
        handleChange("pur_Purity", manualPurchasePurityValue);
      }
    }
  }, [manualPurchasePurityValue]);


  // Calculate display purchase purity: show manual percentage if Manual, otherwise show the purity value
  const displayPurchasePurity = () => {
    const purchasePurity = resolvePurchasePurityValue();
    if (purchasePurity && typeof purchasePurity === "string" && purchasePurity.toLowerCase().includes("manual")) {
      return manualPurchasePurityValue || "Manual";
    }
    return purchasePurity || selectedProduct?.pur_Purity || selectedProduct?.purity || "";
  };

  // Get purchase rate from selectedProduct or formData
  const getPurchaseRate = () => {
    return formData.pur_rate_cut || 
           selectedProduct?.rate_cut || 
           selectedProduct?.pur_rate_cut || 
           "";
  };

  // Get selling purity sum (base + wastage + MC + addon) - only when subcategory is selected
  const getSellingPurityBreakdown = () => {
    // Only calculate if subcategory is selected
    const hasSubCategory = formData?.sub_category && formData.sub_category.trim() !== "";
    if (!hasSubCategory) {
      return null;
    }
    // Use the same calculation as calculateDisplaySellingPurity
    return calculateDisplaySellingPurity();
  };

  // Get purchase purity sum (purity + wastage + MC) - using purchase values only, not subcategory
  const getPurchasePurityBreakdown = () => {
    const parsePercent = (val) => {
      if (val === null || val === undefined || val === "") return 0;
      const s = val.toString().replace("%", "").trim();
      const n = Number(s);
      return Number.isFinite(n) ? n : 0;
    };

    // Base purity from purchase (selectedProduct.purityPercentage)
    const basePurity = parsePercent(
      selectedProduct?.purityPercentage || 
      formData.pur_purityPercentage ||
      0
    );

    // Purchase wastage from purchase (selectedProduct.wastage)
    const purchaseWastage = parsePercent(
      selectedProduct?.wastage ||
      formData?.pur_Wastage_Percentage ||
      0
    );

    // MC (Making Charges) from purchase
    // If MC On is "MC %", use the MC percentage value
    let mcValue = 0;
    if (selectedProduct?.Making_Charges_On === "MC %" || formData.pur_Making_Charges_On === "MC %") {
      // Get MC percentage from purchase
      mcValue = parsePercent(
        selectedProduct?.Making_Charges_Value ||
        formData.pur_MC_Per_Gram ||
        0
      );
    } else {
      // For MC / Gram or MC / Piece, MC doesn't affect purity percentage
      mcValue = 0;
    }

    // Return the sum: purity + wastage + MC
    const total = basePurity + purchaseWastage + mcValue;
    return total > 0 ? total.toFixed(2) : null;
  };

  // Get numeric selling purity value for rate calculation
  const getNumericSellingPurity = () => {
    const parsePercent = (val) => {
      if (val === null || val === undefined || val === "") return 0;
      const s = val.toString().replace("%", "").trim();
      const n = Number(s);
      return Number.isFinite(n) ? n : 0;
    };

    // If subcategory is selected, always use calculated selling purity (from components)
    const hasSubCategory = formData?.sub_category && formData.sub_category.trim() !== "";
    
    if (hasSubCategory) {
      // Always calculate from components when subcategory is selected
      const calculatedPurity = calculateDisplaySellingPurity();
      const parsed = parsePercent(calculatedPurity);
      if (parsed > 0) {
        return parsed;
      }
    }

    // If Purity is "Manual", use the calculated display selling purity
    if (formData.Purity && typeof formData.Purity === "string" && formData.Purity.trim().toLowerCase() === "manual") {
      const calculatedPurity = calculateDisplaySellingPurity();
      return parsePercent(calculatedPurity);
    }
    
    // Otherwise, parse the Purity value directly
    return parsePercent(formData.Purity || displaySellingPurity);
  };

  const handleOpenModal = () => {
    // Normalize pricing value to match SubCategoryV2 format
    let normalizedPricing = formData.Pricing || "By Weight";
    if (normalizedPricing === "By Running Tag") {
      normalizedPricing = "By running tag";
    }
    
    // Get purchase values from formData first (these will be populated when editing)
    // If formData doesn't have them, try to get from selectedProduct (Purchase table data)
    // Purchase table fields: wastage, Making_Charges_Value, purity, rate_cut
    // Priority: formData (if edited) > selectedProduct (from Purchase table)
    const purchasePurity = resolvePurchasePurityValue();
    const normalizedPurchasePurity =
      purchasePurity && purchasePurity.toLowerCase().includes("manual")
        ? "Manual"
        : purchasePurity;
    const purchaseMC = (formData.pur_MC_Per_Gram && formData.pur_MC_Per_Gram !== "") 
      ? formData.pur_MC_Per_Gram 
      : (selectedProduct?.Making_Charges_Value || "");
    const purchaseWastage = (formData.pur_Wastage_Percentage && formData.pur_Wastage_Percentage !== "") 
      ? formData.pur_Wastage_Percentage 
      : (selectedProduct?.wastage || "");
    const purchaseRate = (formData.pur_rate_cut && formData.pur_rate_cut !== "") 
      ? formData.pur_rate_cut 
      : (selectedProduct?.rate_cut || "");
    const printingPurity = formData.printing_purity || "";
    
    const manualPurchasePurity = resolveManualPurchasePurity();
    const orderDetailsData = {
      ...formData,
      // Map purchase fields for SubCategoryV2 - use formData first, fallback to selectedProduct
      purchase_purity: purchasePurity,
      purchase_mc_percent: purchaseMC,
      purchase_wastage_percent: purchaseWastage,
      purchase_rate: purchaseRate,
      printing_purity: printingPurity,
      pricing: normalizedPricing,
      purchase_manual_purity: manualPurchasePurity,
      selling_purity:
        normalizedPurchasePurity ||
        formData.selling_purity ||
        selectedProduct?.selling_purity ||
        "",
    };
    
    navigate("/subcategoryv2", {
      state: {
        orderDetails: [orderDetailsData],
        modalData: selectedProduct,
        from: "/purchasetable",
      },
    });
  };

  const handleCloseModal = () => setShowModal(false);

  useEffect(() => {
    if (!selectedProduct || isEditMode) return;
    if (selectedProduct) {
      setFormData((prevState) => ({
        ...prevState,
        category: selectedProduct.category || "",
        tax_percent:
          getTaxPercentFromSlab(selectedProduct.tax_slab) ||
          prevState.tax_percent,
      }));
    }
  }, [selectedProduct, isEditMode]);

  useEffect(() => {
    const calculateTotalWeight = () => {
      const storedStoneDetails =
        JSON.parse(localStorage.getItem("tagStoneDetails")) || [];

      const totalStoneWeight = storedStoneDetails.reduce(
        (sum, item) => sum + (parseFloat(item.stoneWt) || 0),
        0
      );
      const totalStoneValue = storedStoneDetails.reduce(
        (sum, item) => sum + (parseFloat(item.amount) || 0),
        0
      );

      setFormData((prevData) => ({
        ...prevData,
        Stones_Weight: totalStoneWeight.toFixed(3),
        Stones_Price: totalStoneValue.toFixed(2),
      }));
    };

    calculateTotalWeight();

    const handleStorageChange = () => calculateTotalWeight();
    window.addEventListener("storage", handleStorageChange);

    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  useEffect(() => {
    const calculateTotalWeight = () => {
      const storedStoneDetails =
        JSON.parse(localStorage.getItem("tagPurStoneDetails")) || [];

      const totalStoneWeight = storedStoneDetails.reduce(
        (sum, item) => sum + (parseFloat(item.stoneWt) || 0),
        0
      );
      const totalStoneValue = storedStoneDetails.reduce(
        (sum, item) => sum + (parseFloat(item.amount) || 0),
        0
      );

      setFormData((prevData) => ({
        ...prevData,
        pur_Stones_Weight: totalStoneWeight.toFixed(3),
        pur_Stones_Price: totalStoneValue.toFixed(2),
      }));
    };

    calculateTotalWeight();

    const handleStorageChange = () => calculateTotalWeight();
    window.addEventListener("storage", handleStorageChange);

    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  useEffect(() => {
    const wastagePercentage = parseFloat(formData.Wastage_Percentage) || 0;
    const grossWeight = parseFloat(formData.Gross_Weight) || 0;
    const weightBW = parseFloat(formData.Weight_BW) || 0;
    const purWastagePercentage =
      parseFloat(formData.pur_Wastage_Percentage) || 0;
    const purGrossWeight = parseFloat(formData.pur_Gross_Weight) || 0;
    const purWeightBW = parseFloat(formData.pur_Weight_BW) || 0;

    let wastageWeight = 0;
    let totalWeight = 0;
    let purWastageWeight = 0;
    let purTotalWeight = 0;

    if (formData.Wastage_On === "Gross Weight") {
      wastageWeight = (grossWeight * wastagePercentage) / 100;
      totalWeight = weightBW + wastageWeight;
    } else if (formData.Wastage_On === "Weight BW") {
      wastageWeight = (weightBW * wastagePercentage) / 100;
      totalWeight = weightBW + wastageWeight;
    }

    if (formData.pur_Wastage_On === "Gross Weight") {
      purWastageWeight = (purGrossWeight * purWastagePercentage) / 100;
      purTotalWeight = purWeightBW + purWastageWeight;
    } else if (formData.pur_Wastage_On === "Weight BW") {
      purWastageWeight = (purWeightBW * purWastagePercentage) / 100;
      purTotalWeight = purWeightBW + purWastageWeight;
    }

    setFormData((prev) => ({
      ...prev,
      WastageWeight: wastageWeight.toFixed(3),
      TotalWeight_AW: totalWeight.toFixed(3),
      pur_WastageWeight: purWastageWeight.toFixed(3),
      pur_TotalWeight_AW: purTotalWeight.toFixed(3),
    }));
  }, [
    formData.Wastage_On,
    formData.Wastage_Percentage,
    formData.Gross_Weight,
    formData.Weight_BW,
    formData.pur_Wastage_On,
    formData.pur_Wastage_Percentage,
    formData.pur_Gross_Weight,
    formData.pur_Weight_BW,
  ]);

  const handleMakingChargesCalculation = () => {
    const totalWeight = parseFloat(formData.TotalWeight_AW) || 0;
    const mcPerGram = parseFloat(formData.MC_Per_Gram) || 0;
    const makingCharges = parseFloat(formData.Making_Charges) || 0;
    const purTotalWeight = parseFloat(formData.pur_TotalWeight_AW) || 0;
    const purMcPerGram = parseFloat(formData.pur_MC_Per_Gram) || 0;
    const purMakingCharges = parseFloat(formData.pur_Making_Charges) || 0;

    if (formData.Making_Charges_On === "MC / Gram") {
      // Calculate Making Charges based on MC/Gram
      const calculatedMakingCharges = totalWeight * mcPerGram;
      setFormData((prev) => ({
        ...prev,
        Making_Charges: calculatedMakingCharges.toFixed(2), // Automatically set Making Charges
      }));
    } else if (formData.Making_Charges_On === "MC / Piece") {
      // Calculate MC/Gram based on fixed Making Charges
      const calculatedMcPerGram = totalWeight ? makingCharges / totalWeight : 0;
      setFormData((prev) => ({
        ...prev,
        MC_Per_Gram: calculatedMcPerGram.toFixed(2), // Automatically set MC/Gram
      }));
    }

    if (formData.pur_Making_Charges_On === "MC / Gram") {
      // Calculate Making Charges based on MC/Gram
      const calculatedMakingCharges = purTotalWeight * purMcPerGram;
      setFormData((prev) => ({
        ...prev,
        pur_Making_Charges: calculatedMakingCharges.toFixed(2), // Automatically set Making Charges
      }));
    } else if (formData.pur_Making_Charges_On === "MC / Piece") {
      // Calculate MC/Gram based on fixed Making Charges
      const calculatedMcPerGram = purTotalWeight
        ? purMakingCharges / purTotalWeight
        : 0;
      setFormData((prev) => ({
        ...prev,
        pur_MC_Per_Gram: calculatedMcPerGram.toFixed(2), // Automatically set MC/Gram
      }));
    }
  };

  useEffect(() => {
    handleMakingChargesCalculation();
  }, [
    formData.Making_Charges_On,
    formData.MC_Per_Gram,
    formData.Making_Charges,
    formData.TotalWeight_AW,
    formData.pur_Making_Charges_On,
    formData.pur_MC_Per_Gram,
    formData.pur_Making_Charges,
    formData.pur_TotalWeight_AW,
  ]);

  useEffect(() => {
    axios
      .get(`${baseURL}/get/products`)
      .then((response) => {
        const options = response.data.map((product) => ({
          value: product.product_id,
          label: `${product.product_id}`,
        }));
        setProductOptions(options);
      })
      .catch((error) => console.error("Error fetching products:", error));
  }, []);

  const isGoldCategory =
    formData.category &&
    ["gold", "diamond", "others"].some((metal) =>
      formData.category.toLowerCase().includes(metal)
    );

  const isSilverCategory =
    formData.category && formData.category.toLowerCase().includes("silver");

  useEffect(() => {
    if (isGoldCategory) {
      setFormData((prevData) => ({
        ...prevData,
        Making_Charges_On: "MC %",
        MC_Per_Gram_Label: "MC%",
        Making_Charges: "", // Reset field when hidden
      }));
    } else if (isSilverCategory) {
      setFormData((prevData) => ({
        ...prevData,
        Making_Charges_On: "MC / Gram",
        MC_Per_Gram_Label: "MC/Gm",
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        MC_Per_Gram_Label: "MC/Gm",
      }));
    }
  }, [formData.category]);

  useEffect(() => {
    if (isGoldCategory) {
      setFormData((prevData) => ({
        ...prevData,
        pur_Making_Charges_On: "MC %",
        pur_MC_Per_Gram_Label: "MC%",
        pur_Making_Charges: "", // Reset field when hidden
      }));
    } else if (isSilverCategory) {
      setFormData((prevData) => ({
        ...prevData,
        pur_Making_Charges_On: "MC / Gram",
        pur_MC_Per_Gram_Label: "MC/Gm",
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        pur_MC_Per_Gram_Label: "MC/Gm",
      }));
    }
  }, [formData.category]);

  const [rates, setRates] = useState({
    rate_24crt: "",
    rate_22crt: "",
    rate_18crt: "",
    rate_16crt: "",
  });

  useEffect(() => {
    const fetchRates = async () => {
      try {
        const response = await axios.get(`${baseURL}/get/current-rates`);
        const fetchedRates = {
          rate_24crt: response.data.rate_24crt || "",
          rate_22crt: response.data.rate_22crt || "",
          rate_18crt: response.data.rate_18crt || "",
          rate_16crt: response.data.rate_16crt || "",
          silver_rate: response.data.silver_rate || "",
        };
        setRates(fetchedRates);
        
        // Also update rate_24k in formData if not already set or if subcategory is not set yet
        const sub = formData.sub_category || "";
        const firstWord = sub.split(" ")[0]?.toLowerCase() || "";
        const metalType = (formData.metal_type || selectedProduct?.metal_type || "").toLowerCase();
        const isSilver = firstWord === "silver" || metalType.includes("silver");
        
        const newRate24k = isSilver 
          ? (fetchedRates.silver_rate || formData.rate_24k || "") 
          : (fetchedRates.rate_24crt || formData.rate_24k || "");
        
        setFormData((prev) => ({
          ...prev,
          rate_24k: newRate24k,
        }));
      } catch (error) {
        console.error("Error fetching current rates:", error);
      }
    };
    fetchRates();
  }, []);

  useEffect(() => {
    // Calculate purchase rate using purchase values only (purity + wastage + MC) - NOT subcategory values
    const parsePercent = (val) => {
      if (val === null || val === undefined || val === "") return 0;
      const s = val.toString().replace("%", "").trim();
      const n = Number(s);
      return Number.isFinite(n) ? n : 0;
    };

    // Get base purity from purchase (selectedProduct.purityPercentage)
    const basePurity = parsePercent(
      selectedProduct?.purityPercentage || 
      formData.pur_purityPercentage ||
      0
    );

    // Get purchase wastage from purchase (selectedProduct.wastage)
    const purchaseWastage = parsePercent(
      selectedProduct?.wastage ||
      formData?.pur_Wastage_Percentage ||
      0
    );
    
    // Get MC (Making Charges) from purchase
    // If MC On is "MC %", use the MC percentage value
    let mcValue = 0;
    if (selectedProduct?.Making_Charges_On === "MC %" || formData.pur_Making_Charges_On === "MC %") {
      // Get MC percentage from purchase
      mcValue = parsePercent(
        selectedProduct?.Making_Charges_Value ||
        formData.pur_MC_Per_Gram ||
        0
      );
    }
    // For MC / Gram or MC / Piece, MC doesn't affect purity percentage
    
    // Total purity = base purity + wastage + MC (using purchase values only)
    const totalPurityPercent = basePurity + purchaseWastage + mcValue;
    

    if (!totalPurityPercent || totalPurityPercent <= 0) return;

    const metalType = (formData.metal_type || "").toLowerCase();
    const baseRate = metalType.includes("silver")
      ? parseNumericValue(rates.silver_rate) ||
        parseNumericValue(formData.rate_24k) ||
        parseNumericValue(rates.rate_24crt)
      : parseNumericValue(formData.rate_24k) ||
        parseNumericValue(rates.rate_24crt);

    if (!baseRate) return;

    // Calculate rate based on total purity: (totalPurity / 100) * baseRate
    const calculatedRate = ((totalPurityPercent / 100) * baseRate).toFixed(2);

    setFormData((prev) =>
      prev.pur_rate_cut === calculatedRate
        ? prev
        : {
            ...prev,
            pur_rate_cut: calculatedRate,
          }
    );
  }, [
    formData.pur_purityPercentage,
    formData.pur_Wastage_Percentage,
    formData.pur_Making_Charges_On,
    formData.pur_MC_Per_Gram,
    formData.metal_type,
    formData.rate_24k,
    rates,
    selectedProduct?.purityPercentage,
    selectedProduct?.wastage,
    selectedProduct?.Making_Charges_On,
    selectedProduct?.Making_Charges_Value,
  ]);

  const handleChange = async (fieldOrEvent, valueArg) => {
    let field, value;
    if (fieldOrEvent && fieldOrEvent.target) {
      field = fieldOrEvent.target.name;
      value = fieldOrEvent.target.value;

      // Handle file input
      if (fieldOrEvent.target.type === "file") {
        const file = fieldOrEvent.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onloadend = () => {
            setFormData((prev) => ({
              ...prev,
              productImage: file, // Store actual file
              imagePreview: reader.result, // Store preview for display
            }));
          };
          reader.readAsDataURL(file);
        }
        return;
      }
    } else {
      field = fieldOrEvent;
      value = valueArg;
    }

    if (field === "mrp_per_pcs") {
      const perValue = parseFloat(value);
      const pcsVal = parseFloat(formData.pcs) || 0;
      const totalMrp =
        Number.isFinite(perValue) && pcsVal > 0 ? perValue * pcsVal : perValue;

      setFormData((prevData) => ({
        ...prevData,
        mrp_per_pcs: value,
        mrp_price:
          Number.isFinite(totalMrp) && totalMrp >= 0
            ? totalMrp.toFixed(2)
            : prevData.mrp_price,
      }));
      return;
    }

    if (["sub_category", "category", "design_master"].includes(field)) {
      const updatedFormData = { ...formData, [field]: value };

      const selectedCategory = subCategories.find(
        (category) =>
          category.sub_category_name === updatedFormData.sub_category
      );

      const getPrefixLetters = (str) =>
        str
          ? str
              .split(" ")
              .map((word) => word[0]?.toUpperCase())
              .join("")
          : "";

      const categoryPrefix = getPrefixLetters(updatedFormData.category);
      const designPrefix = getPrefixLetters(updatedFormData.design_master);
      // const subPrefix = selectedCategory?.prefix || "";
      const subPrefix = getPrefixLetters(updatedFormData.sub_category);

      const combinedPrefix = [categoryPrefix, subPrefix, designPrefix]
        .filter(Boolean)
        .join("-");

      if (selectedCategory) {
        try {
          // Fetch full subcategory details from API
          const subcategoryResponse = await axios.get(
            `${baseURL}/subcategory/${selectedCategory.subcategory_id}`
          );
          const fullSubcategoryData = subcategoryResponse.data;
          
          // Fetch next PCode/BarCode based on subcategory prefix only
          const response = await axios.get(`${baseURL}/getNextPCodeBarCode`, {
            params: { prefix: subPrefix },
          });

          const nextPCodeBarCode = response.data.nextPCodeBarCode; // e.g. GRN002
          const suffix = nextPCodeBarCode.replace(subPrefix, "");
          let finalCode = combinedPrefix;

          if (formData.Pricing === "By Running Tag") {
            finalCode += `-RT${suffix}`;
          } else {
            finalCode += suffix;
          }

          setFormData((prevData) => ({
            ...prevData,
            ...updatedFormData,
            subcategory_id: selectedCategory.subcategory_id,
            item_prefix: combinedPrefix,
            Prefix: combinedPrefix,
            PCode_BarCode: finalCode,
            suffix,
            Purity: fullSubcategoryData.selling_purity || selectedCategory.selling_purity || selectedCategory.selling_rate || "",
            pur_Purity: fullSubcategoryData.purchase_purity || selectedCategory.purchase_purity || selectedCategory.purchase_rate || "",
            Making_Charges: fullSubcategoryData.mc_on || selectedCategory.mc_on || "",
            Making_Charges_On: fullSubcategoryData.mc_on || selectedCategory.mc_on || "",
            Wastage_Percentage: fullSubcategoryData.selling_wastage_percent || selectedCategory.selling_wastage_percent || "",
            printing_purity: fullSubcategoryData.printing_purity || selectedCategory.printing_purity || "",
            MC_Per_Gram: fullSubcategoryData.selling_mc_percent ?? selectedCategory.selling_mc_percent ?? "",
            pur_MC_Per_Gram: fullSubcategoryData.purchase_mc_percent ?? selectedCategory.purchase_mc_percent ?? "",
            pur_Wastage_Percentage:
              fullSubcategoryData.purchase_wastage_percent ?? selectedCategory.purchase_wastage_percent ?? "",
            selling_addon_purity: fullSubcategoryData.selling_addon_purity ?? selectedCategory.selling_addon_purity ?? "",
            selling_addon_mc_percent: fullSubcategoryData.selling_addon_mc_percent ?? selectedCategory.selling_addon_mc_percent ?? "",
            selling_addon_wastage_percent: fullSubcategoryData.selling_addon_wastage_percent ?? selectedCategory.selling_addon_wastage_percent ?? "",
            custom_purity: fullSubcategoryData.custom_purity ?? selectedCategory.custom_purity ?? "",
          }));
        } catch (error) {
          console.error("Error fetching subcategory details or PCode_BarCode:", error);
          // Fallback to using selectedCategory data if API call fails
          setFormData((prevData) => ({
            ...prevData,
            ...updatedFormData,
            subcategory_id: selectedCategory.subcategory_id,
            item_prefix: combinedPrefix,
            Prefix: combinedPrefix,
            PCode_BarCode: "",
            suffix: "",
            Purity: selectedCategory.selling_purity || selectedCategory.selling_rate || "",
            pur_Purity: selectedCategory.purchase_purity || selectedCategory.purchase_rate || "",
            Making_Charges: selectedCategory.mc_on || "",
            Making_Charges_On: selectedCategory.mc_on || "",
            Wastage_Percentage: selectedCategory.selling_wastage_percent || "",
            printing_purity: selectedCategory.printing_purity || "",
            MC_Per_Gram: selectedCategory.selling_mc_percent ?? "",
            pur_MC_Per_Gram: selectedCategory.purchase_mc_percent ?? "",
            pur_Wastage_Percentage: selectedCategory.purchase_wastage_percent ?? "",
            selling_addon_purity: selectedCategory.selling_addon_purity ?? "",
          }));
        }
      } else {
        setFormData((prevData) => ({
          ...prevData,
          ...updatedFormData,
          subcategory_id: "",
          item_prefix: "",
          Prefix: "",
          PCode_BarCode: "",
          suffix: "",
          Purity: "",
          pur_Purity: "",
          Making_Charges: "",
          Making_Charges_On: "",
          Wastage_Percentage: "",
          printing_purity: "",
          MC_Per_Gram: "",
          pur_Wastage_Percentage: "",
          pur_MC_Per_Gram: "",
          selling_addon_purity: "",
        }));
      }
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [field]: value,
      }));
    }

    setFormData((prevData) => {
      let updatedData = { ...prevData, [field]: value };

      if (field === "Gross_Weight") {
        updatedData.pur_Gross_Weight = value;
      }

      // Update MC field only if Making_Charges_On is "MC / Gram" or "MC / Piece"
      if (field === "Making_Charges_On") {
        if (value === "MC / Gram" || value === "MC / Piece") {
          updatedData.Making_Charges = prevData.Making_Charges || "";
        } else {
          updatedData.Making_Charges = ""; // Hide field
        }
      }

      if (field === "pur_Making_Charges_On") {
        if (value === "MC / Gram" || value === "MC / Piece") {
          updatedData.pur_Making_Charges = prevData.pur_Making_Charges || "";
        } else {
          updatedData.pur_Making_Charges = ""; // Hide field
        }
      }

      // Update MC_Per_Gram_Label when Making_Charges_On changes
      if (field === "Making_Charges_On") {
        let newLabel = "MC/Gm"; // Default
        if (value === "MC %") newLabel = "MC%";
        else if (value === "MC / Gram") newLabel = "MC/Gm";
        else if (value === "MC / Piece") newLabel = "MC/Gm";

        updatedData.MC_Per_Gram_Label = newLabel;
      }

      if (field === "pur_Making_Charges_On") {
        let newLabel = "MC/Gm"; // Default
        if (value === "MC %") newLabel = "MC%";
        else if (value === "MC / Gram") newLabel = "MC/Gm";
        else if (value === "MC / Piece") newLabel = "MC/Gm";

        updatedData.pur_MC_Per_Gram_Label = newLabel;
      }

      // --- Calculate Stones Price ---
      if (field === "Stones_Weight" || field === "stone_price_per_carat") {
        const stoneWeight =
          parseFloat(
            field === "Stones_Weight" ? value : prevData.Stones_Weight
          ) || 0;
        const stonePricePerCarat =
          parseFloat(
            field === "stone_price_per_carat"
              ? value
              : prevData.stone_price_per_carat
          ) || 0;
        if (stoneWeight > 0 && stonePricePerCarat > 0) {
          const calculatedStonePrice = (stoneWeight / 0.2) * stonePricePerCarat;
          updatedData.Stones_Price = calculatedStonePrice.toFixed(2);
        } else {
          updatedData.Stones_Price = "";
        }
      }

      if (
        field === "pur_Stones_Weight" ||
        field === "pur_stone_price_per_carat"
      ) {
        const stoneWeight =
          parseFloat(
            field === "pur_Stones_Weight" ? value : prevData.pur_Stones_Weight
          ) || 0;
        const stonePricePerCarat =
          parseFloat(
            field === "pur_stone_price_per_carat"
              ? value
              : prevData.pur_stone_price_per_carat
          ) || 0;
        if (stoneWeight > 0 && stonePricePerCarat > 0) {
          const calculatedStonePrice = (stoneWeight / 0.2) * stonePricePerCarat;
          updatedData.pur_Stones_Price = calculatedStonePrice.toFixed(2);
        } else {
          updatedData.pur_Stones_Price = "";
        }
      }

      // --- Recalculate Weight BW ---
      if (
        field === "Gross_Weight" ||
        field === "Stones_Weight" ||
        field === "deduct_st_Wt" ||
        field === "pur_Gross_Weight" ||
        field === "pur_Stones_Weight" ||
        field === "pur_deduct_st_Wt"
      ) {
        // For normal weight calculation
        const grossWt = parseFloat(updatedData.Gross_Weight) || 0;
        const stonesWt = parseFloat(updatedData.Stones_Weight) || 0;
        const deductOption = updatedData.deduct_st_Wt
          ? updatedData.deduct_st_Wt.toLowerCase()
          : "";

        if (deductOption === "yes") {
          updatedData.Weight_BW = (grossWt - stonesWt).toFixed(2);
        } else {
          updatedData.Weight_BW = grossWt.toFixed(2);
        }

        // For purchase weight calculation
        const purGrossWt = parseFloat(updatedData.pur_Gross_Weight) || 0;
        const purStonesWt = parseFloat(updatedData.pur_Stones_Weight) || 0;
        const purDeductOption = updatedData.pur_deduct_st_Wt
          ? updatedData.pur_deduct_st_Wt.toLowerCase()
          : "";

        if (purDeductOption === "yes") {
          updatedData.pur_Weight_BW = (purGrossWt - purStonesWt).toFixed(2);
        } else {
          updatedData.pur_Weight_BW = purGrossWt.toFixed(2);
        }
      }
      if (
        field === "pieace_cost" ||
        field === "tax_percent" ||
        field === "pcs"||
        field === "mrp_price"
      ) {
        const pcs =
          parseFloat(field === "pcs" ? value : prevData.pcs) || 0;
        const pieceCost =
          parseFloat(field === "pieace_cost" ? value : prevData.pieace_cost) || 0;
        const taxPercent =
          parseFloat(field === "tax_percent" ? value : prevData.tax_percent) || 0;

        if (prevData.Pricing === "By Running Tag") {
          if (field === "mrp_price") {
            if (value === "" || value === null || value === undefined) {
              updatedData.mrp_price = "";
              return updatedData;
            }
            const mrp = parseFloat(value) || 0;

            const baseAmount = (mrp * 100) / (100 + taxPercent);
            const derivedPieceCost = pcs > 0 ? baseAmount / pcs : 0;

            updatedData.pieace_cost = derivedPieceCost.toFixed(2);
            updatedData.total_pcs_cost = baseAmount.toFixed(2);
            updatedData.mrp_price = mrp.toFixed(2);
            updatedData.mrp_per_pcs =
              pcs > 0 ? (mrp / pcs).toFixed(2) : updatedData.mrp_per_pcs;
          }
          else {
            const baseAmount = pcs * pieceCost;
            const tax = (baseAmount * taxPercent) / 100;

            updatedData.mrp_price = (baseAmount + tax).toFixed(2);
            updatedData.mrp_per_pcs =
              pcs > 0
                ? ((baseAmount + tax) / pcs).toFixed(2)
                : updatedData.mrp_per_pcs;
            updatedData.total_pcs_cost = baseAmount.toFixed(2);
          }
        }
      }

      // Update MRP Price and Total Pcs Cost when Pricing is "By fixed"
      if (prevData.Pricing !== "By Running Tag") {
        if (field === "pieace_cost" || field === "tax_percent") {
          const taxPercent =
            parseFloat(field === "tax_percent" ? value : prevData.tax_percent) ||
            0;
          const pieaceCost =
            parseFloat(field === "pieace_cost" ? value : prevData.pieace_cost) ||
            0;
          const mrpPrice = (pieaceCost * taxPercent) / 100 + pieaceCost;
          updatedData.mrp_price = mrpPrice.toFixed(2);
          updatedData.mrp_per_pcs =
            pcs > 0 ? (mrpPrice / pcs).toFixed(2) : updatedData.mrp_per_pcs;

          // updatedData.mrp_price = ((pieaceCost / (100 + taxPercent)) * 100).toFixed(2);
        }

        if (field === "pieace_cost" || field === "pcs") {
          const pcs = parseFloat(field === "pcs" ? value : prevData.pcs) || 0;
          const pieaceCost =
            parseFloat(field === "pieace_cost" ? value : prevData.pieace_cost) ||
            0;
          updatedData.total_pcs_cost = (pcs * pieaceCost).toFixed(2);
        }

        // If user enters MRP Price, update pieace_cost and total_pcs_cost
        if (field === "mrp_price") {
          const mrpPrice = parseFloat(value) || 0;
          const taxPercent = parseFloat(prevData.tax_percent) || 0;

          // Calculate Pieace Cost
          const pieaceCost = (mrpPrice / (100 + taxPercent)) * 100;
          updatedData.pieace_cost = pieaceCost.toFixed(2);

          // Update Total Pcs Cost
          const pcs = parseFloat(prevData.pcs) || 0;
          updatedData.total_pcs_cost = (pcs * pieaceCost).toFixed(2);
          updatedData.mrp_per_pcs =
            pcs > 0 ? (mrpPrice / pcs).toFixed(2) : updatedData.mrp_per_pcs;
        }
      }
      return updatedData;
    });

    // --- Handle Category Change ---
    if (field === "category") {
      setFormData((prevData) => ({
        ...prevData,
        category: value,
      }));
      return;
    }
    if (field === "MP_Per_Gram" || field === "MP_amount") {
      setFormData((prevData) => ({
        ...prevData,
        [field]: value,
      }));
      return;
    }
    if (field === "Purity") {
      // Calculate rate based on selling purity (not purchase purity)
      const sellingPurity = getNumericSellingPurity();
      // Get base 24k rate with fallback to rates state (same logic as purchase rate calculation)
      const metalType = (formData.metal_type || "").toLowerCase();
      const base24Rate = metalType.includes("silver")
        ? parseFloat(formData.rate_24k) || parseFloat(rates.silver_rate) || 0
        : parseFloat(formData.rate_24k) || parseFloat(rates.rate_24crt) || 0;

      if (sellingPurity > 0 && base24Rate > 0) {
        const calculatedRate = ((sellingPurity / 100) * base24Rate).toFixed(2);

        setFormData((prevData) => {
          let updatedData = { ...prevData, [field]: value };
          updatedData.rate = calculatedRate;
          return updatedData;
        });
      }
      setFormData((prevData) => ({
        ...prevData,
        [field]: value, 
      }));
      return;
    }
  };

  // Recalculate rate based on selling purity whenever selling purity components change
  useEffect(() => {
    if (formData.Pricing === "By Weight" || formData.Pricing === "By Running Tag") {
      // Use getNumericSellingPurity to get the correct selling purity value
      const sellingPurity = getNumericSellingPurity();


      // Get base 24k rate with fallback to rates state (same logic as purchase rate calculation)
      const metalType = (formData.metal_type || "").toLowerCase();
      
      const rate24kValue = parseFloat(formData.rate_24k) || 0;
      const rate24crtValue = parseFloat(rates.rate_24crt) || 0;
      const silverRateValue = parseFloat(rates.silver_rate) || 0;
      
      const base24Rate = metalType.includes("silver")
        ? (rate24kValue || silverRateValue || 0)
        : (rate24kValue || rate24crtValue || 0);
      
      const sellingRate = sellingPurity > 0 && base24Rate > 0 ? (sellingPurity / 100) * base24Rate : 0;

      if (sellingRate > 0) {
        setFormData((prev) => {
          if (prev.rate !== sellingRate.toFixed(2)) {
            return {
              ...prev,
              rate: sellingRate.toFixed(2),
            };
          } else {
          }
          return prev;
        });
      } else {
      }
    } else {
    }
  }, [
    formData.Pricing,
    formData.Purity,
    formData.rate_24k,
    formData.custom_purity,
    formData.sub_category,
    formData.pur_purityPercentage,
    formData.pur_Wastage_Percentage,
    formData.pur_MC_Per_Gram,
    formData.selling_addon_purity,
    formData.selling_addon_mc_percent,
    formData.selling_addon_wastage_percent,
    formData.Making_Charges_On,
    formData.MC_Per_Gram,
    formData.metal_type,
    rates,
    selectedProduct,
    subData,
    subCategories,
  ]);

  useEffect(() => {
  // Run only for "By Weight" pricing
    if (formData.Pricing === "By Weight") {

      const rate = parseFloat(formData.rate) || 0;
      const grossWeight = parseFloat(formData.Gross_Weight) || 0;
      const mpPercent = parseFloat(formData.MP_Per_Gram) || 0;
      const mcPercent = parseFloat(formData.MC_Per_Gram) || 0;

      // Base value: rate * gross weight
      const baseValue = rate * grossWeight;

      let finalMPAmount = baseValue;

      // If MC_Per_Gram_Label contains "MC %" then calculate percent-based MP
      if (formData.MC_Per_Gram_Label?.includes("MC%")) {
        const percentValue = (baseValue * (mpPercent+mcPercent)) / 100;
        finalMPAmount = baseValue + percentValue;
      }else if (formData.MC_Per_Gram_Label?.includes("MC/Gm")){
        const mcGramExtra = (mpPercent + mcPercent) * grossWeight;
        finalMPAmount = baseValue + mcGramExtra;
      }

      // Update MP_amount in formData
        setFormData((prev) => ({
          ...prev,
          MP_amount: finalMPAmount.toFixed(3),
        }));
    }
    if (formData.Pricing === "By fixed") {
        const pcs = parseFloat(formData.pcs) || 0;
        const mpPercent = parseFloat(formData.MP_Per_Gram) || 0;

        // MP amount = MP_Per_Gram * pcs
        const mpAmount = mpPercent * pcs;

        // update MRP price = existing MRP + mpAmount
        const oldMrp = parseFloat(formData.pieace_cost) * pcs;
        const newMRP = oldMrp + mpAmount;

        setFormData((prev) => ({
          ...prev,
          MP_amount: newMRP.toFixed(3),
        }));
      } 
      
    }, [
    formData.MP_Per_Gram, formData.MC_Per_Gram
  ]);

  useEffect(() => {
    const pcsVal = parseFloat(formData.pcs);
    const pieceCostVal = parseFloat(formData.pieace_cost);
    const taxPercentVal = parseFloat(formData.tax_percent);

    if (!Number.isFinite(pcsVal) || pcsVal <= 0) return;
    if (!Number.isFinite(pieceCostVal) || pieceCostVal <= 0) return;
    if (!Number.isFinite(taxPercentVal)) return;

    let computedTotal = pcsVal * pieceCostVal;
    let computedMrp;

    if (formData.Pricing === "By fixed") {
      const taxAmount = (pieceCostVal * taxPercentVal) / 100;
      computedMrp = pieceCostVal + taxAmount;
    } else {
      const taxAmount = (computedTotal * taxPercentVal) / 100;
      computedMrp = computedTotal + taxAmount;
    }

    const nextState = {};
    const nextTotal = Number.isFinite(computedTotal)
      ? computedTotal.toFixed(2)
      : "0.00";
    const nextMrp = Number.isFinite(computedMrp)
      ? computedMrp.toFixed(2)
      : "0.00";
    const nextMrpPerPcs =
      pcsVal > 0 && Number.isFinite(computedMrp)
        ? (computedMrp / pcsVal).toFixed(2)
        : "";

    if (formData.total_pcs_cost !== nextTotal) {
      nextState.total_pcs_cost = nextTotal;
    }

    if (formData.mrp_price !== nextMrp) {
      nextState.mrp_price = nextMrp;
    }

    if (formData.mrp_per_pcs !== nextMrpPerPcs) {
      nextState.mrp_per_pcs = nextMrpPerPcs;
    }

    if (Object.keys(nextState).length) {
      setFormData((prev) => ({
        ...prev,
        ...nextState,
      }));
    }
  }, [
    formData.pcs,
    formData.pieace_cost,
    formData.tax_percent,
    formData.Pricing,
  ]);

  // Calculate piece cost for "By Running Tag" from gross weight and selling rate
  // Uses selling purity to calculate the rate, then: rate * gross weight / pcs
  useEffect(() => {
    if (formData.Pricing === "By Running Tag") {
      // Use getNumericSellingPurity to get the correct selling purity value
      const sellingPurity = getNumericSellingPurity();

      // Get base 24k rate with fallback to rates state (same logic as purchase rate calculation)
      const metalType = (formData.metal_type || "").toLowerCase();
      const base24Rate = metalType.includes("silver")
        ? parseFloat(formData.rate_24k) || parseFloat(rates.silver_rate) || 0
        : parseFloat(formData.rate_24k) || parseFloat(rates.rate_24crt) || 0;
      const sellingRate = sellingPurity > 0 && base24Rate > 0 ? (sellingPurity / 100) * base24Rate : 0;
      const grossWeight = parseFloat(formData.Gross_Weight) || 0;
      const pcs = parseFloat(formData.pcs) || 1;

      // Only calculate if we have both selling rate and gross weight, and pcs > 0
      if (sellingRate > 0 && grossWeight > 0 && pcs > 0) {
        // Calculate total amount: selling rate * gross weight
        const totalAmount = sellingRate * grossWeight;
        
        // Calculate piece cost: total amount / pcs
        const calculatedPieceCost = totalAmount / pcs;

        // Update piece cost and rate (for display purposes)
        setFormData((prev) => {
          // Only update if the value actually changed to avoid infinite loops
          if (prev.pieace_cost !== calculatedPieceCost.toFixed(2)) {
            return {
            ...prev,
            pieace_cost: calculatedPieceCost.toFixed(2),
            rate: sellingRate.toFixed(2), // Store selling rate for reference
          };
          }
          return prev;
        });
      } else {
        // Reset piece cost if required values are missing
        setFormData((prev) => {
          if (prev.pieace_cost !== "" && (sellingRate === 0 || grossWeight === 0 || pcs === 0)) {
            return {
              ...prev,
              pieace_cost: "",
            };
          }
          return prev;
        });
      }
    }
  }, [
    formData.Pricing,
    formData.Purity,
    formData.rate_24k,
    formData.Gross_Weight,
    formData.pcs,
    formData.sub_category,
    formData.custom_purity,
    formData.pur_purityPercentage,
    formData.pur_Wastage_Percentage,
    formData.pur_MC_Per_Gram,
    formData.selling_addon_purity,
    formData.selling_addon_mc_percent,
    formData.selling_addon_wastage_percent,
    formData.Making_Charges_On,
    formData.MC_Per_Gram,
    formData.Wastage_Percentage,
    formData.metal_type,
    selectedProduct,
    subData,
    subCategories,
    rates,
    displaySellingPurity,
  ]);

  const isSilverOrGold = /silver|gold/i.test(formData.category);

  const isGeneratePDFRef = useRef(isGeneratePDF); // Create a ref to track latest state

  useEffect(() => {
    isGeneratePDFRef.current = isGeneratePDF; // Update ref whenever state changes
  }, [isGeneratePDF]);

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.altKey && event.key.toLowerCase() === "s") {
        event.preventDefault(); // Prevent default behavior

        // Ensure latest values are used
        const pcsValue = parseFloat(formData.pcs) || 0;
        const grossWeightValue = parseFloat(formData.Gross_Weight) || 0;


        if (formData.Pricing === "By fixed" && pcsValue <= 0) {
          alert(
            "The product's PCS must be greater than zero to submit the form."
          );
          return;
        }

        if (
          formData.Pricing === "By fixed" &&
          (!formData.pieace_cost || parseFloat(formData.pieace_cost) <= 0)
        ) {
          alert("Please enter a Piece Cost.");
          return;
        }

        if (
          formData.Pricing !== "By fixed" &&
          (pcsValue <= 0 || grossWeightValue <= 0)
        ) {
          alert(
            "The product's PCS and Gross Weight must be greater than zero to submit the form."
          );
          return;
        }

        if (!formData.sub_category || !formData.subcategory_id) {
          alert("Please select a valid sub-category before submitting.");
          return;
        }

        if (formData.Pricing === "By Weight" && !formData.Gross_Weight) {
          alert("Please add Gross Weight");
          return;
        }

        handleSubmit(); // Call submit function after validations
      }
    };

    window.addEventListener("keydown", handleKeyPress);
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [formData]);

  // const captureImage = () => {
  //     if (webcamRef.current) {
  //         const imageSrc = webcamRef.current.getScreenshot();
  //         setFormData((prev) => ({
  //             ...prev,
  //             imagePreview: imageSrc,
  //             productImage: imageSrc,
  //         }));
  //         setShowWebcam(false);
  //     }
  // };

  // const clearImage = () => {
  //     setFormData((prev) => ({
  //         ...prev,
  //         productImage: null,
  //         imagePreview: null,
  //     }));
  // };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result); // Convert image to base64 and update state
      };
      reader.readAsDataURL(file);
    }
  };

  const captureImage = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    setImage(imageSrc);
    setIsCameraOpen(false);
  };

  const clearImage = () => {
    setImage(null);
  };

  const [showDesignModal, setShowDesignModal] = useState(false);
  const [newDesign, setNewDesign] = useState({
    design_name: "",
    design_prefix: "",
    category: formData.category,
  });

  const handleOpenDesignModal = () => setShowDesignModal(true);
  const handleCloseDesignModal = () => setShowDesignModal(false);

  const handleDesignModalChange = (e) => {
    setNewDesign({ ...newDesign, [e.target.name]: e.target.value });
  };

  const handleAddDesign = async () => {
    if (!newDesign.design_name) {
      alert("Product Design Name required!");
      return;
    }

    try {
      const response = await axios.post(`${baseURL}/designmaster`, {
        category: newDesign.category || formData.category,
        design_name: newDesign.design_name,
        metal: newDesign.metal || formData.metal_type, // Storing metal type in the DB
      });

      if (response.status === 201 || response.status === 200) {
        alert("Product Design Name added successfully!");

        // Close modal and reset form
        handleCloseDesignModal();
        setNewDesign({
          design_name: "",
          metal: formData.metal_type,
          category: formData.category,
        });

        // Refresh design list
        await fetchDesignMaster();

        // Fetch updated design list
        const updatedResponse = await axios.get(`${baseURL}/designmaster`);
        const updatedDesignMasters = updatedResponse.data.map((item) => ({
          value: item.design_name,
          label: item.design_name,
          id: item.design_id,
        }));

        setdesignOptions(updatedDesignMasters);

        // Find and auto-select the newly added design
        const addedDesign = updatedDesignMasters.find(
          (design) => design.value === newDesign.design_name
        );

        if (addedDesign) {
          setFormData((prevData) => ({
            ...prevData,
            design_master: addedDesign.value, // Store selected design name
            design_id: addedDesign.id, // Store the design ID
          }));
        }
      }
    } catch (error) {
      console.error("Error adding Product Design Name:", error);
      alert("Failed to add Product Design Name. Please try again.");
    }
  };

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();

    if (formData.Pricing === "By fixed") {
      if (pcs <= 0) {
        alert(
          "The product's PCS must be greater than zero to submit the form."
        );
        return;
      }
      if (!formData.pieace_cost || parseFloat(formData.pieace_cost) <= 0) {
        alert("Please enter a Piece Cost.");
        return;
      }
    } else {
      if (pcs <= 0 || grossWeight <= 0) {
        alert(
          "The product's PCS and Gross Weight must be greater than zero to submit the form."
        );
        return;
      }
    }
    if (!formData.Stock_Point) {
      alert("Please select a Stock Point before submitting.");
      return;
    }
    if (!formData.sub_category) {
      alert("Please select a valid sub-category before submitting.");
      return;
    }
    if (!formData.design_master) {
      alert("Please select a valid design name before submitting.");
      return;
    }

    if (formData.Pricing === "By Weight" && !formData.Gross_Weight) {
      alert("Please add Gross Weight");
      return;
    }

    // **Check if Gross Weight exceeds the limit**
    if (parseFloat(formData.Gross_Weight) > parseFloat(grossWeight)) {
      const diff = (
        parseFloat(formData.Gross_Weight) - parseFloat(grossWeight)
      ).toFixed(3);
      const confirmSubmit = window.confirm(
        `The tag gross weight exceeds by ${diff} of balance Gross Weight. Do you want to proceed?`
      );
      if (!confirmSubmit) {
        return; // Stop submission if user clicks "No"
      }
    }
    // Variables to store calculated values for "By Running Tag"
    let calculatedPcs = null;
    let calculatedRemPcs = null;
    let calculatedGrossWeight = null;

    if (formData.Pricing === "By Running Tag" && !formData.opentag_id) {
      const balPcs = parseFloat(pcs);            
      const userPcs = parseFloat(formData.pcs);  
      const balGross = parseFloat(grossWeight);
      const userEnteredGrossWeight = parseFloat(formData.Gross_Weight) || 0;


      if (!userPcs || userPcs <= 0) {
        alert("PCS must be greater than zero.");
        return;
      }

      if (userPcs > balPcs) {
        alert("Entered PCS is greater than Balance PCS!");
        return;
      }

      // Use manually entered gross weight if provided, otherwise calculate proportionally
      let finalGrossWeight;
      if (userEnteredGrossWeight > 0) {
        // Use the manually entered gross weight
        finalGrossWeight = userEnteredGrossWeight;
      } else {
        // Calculate proportional gross weight for the single tag
        const proportionalGross = (userPcs / balPcs) * balGross;
        finalGrossWeight = proportionalGross;
      }
      
      // Store calculated values to use in payload
      calculatedPcs = userPcs.toString();
      calculatedRemPcs = userPcs.toString();
      // Send as number, not string, to ensure backend accepts it properly
      calculatedGrossWeight = parseFloat(finalGrossWeight.toFixed(3));
      
      
      // Update formData with calculated gross weight and PCS
      setFormData((prevData) => ({
        ...prevData,
        pcs: calculatedPcs,
        rem_pcs: calculatedRemPcs,
        Gross_Weight: calculatedGrossWeight,
      }));
    }

    setSaveLoader(true);

    try {
      // Build updatedData with proper overrides
      const overrides = {
        image,
      };

      // For "By Running Tag", override with calculated values
      if (calculatedPcs !== null) {
        overrides.pcs = calculatedPcs;
      }
      if (calculatedRemPcs !== null) {
        overrides.rem_pcs = calculatedRemPcs;
      }
      if (calculatedGrossWeight !== null) {
        overrides.Gross_Weight = calculatedGrossWeight;
      }
      if (!overrides.rem_pcs) {
        overrides.rem_pcs = formData.pcs || pcs;
      }

      let payload = buildOpeningTagPayload(formData, overrides);

      // Additional safeguard: If Pricing is "By Running Tag" and Gross_Weight is missing/zero, recalculate
      if (
        payload.Pricing === "By Running Tag" &&
        (!payload.Gross_Weight || parseFloat(payload.Gross_Weight) === 0)
      ) {
        const balPcs = parseFloat(pcs);
        const userPcs = parseFloat(payload.pcs);
        const balGross = parseFloat(grossWeight);
        
        if (balPcs > 0 && userPcs > 0 && balGross > 0) {
          const proportionalGross = (userPcs / balPcs) * balGross;
          payload.Gross_Weight = parseFloat(proportionalGross.toFixed(3));
        }
      }

      let apiURL = `${baseURL}/post/opening-tags-entry`; // Default: Add new entry
      let method = "POST";
      let isUpdating = false;

      if (formData.opentag_id) {
        apiURL = `${baseURL}/update/opening-tags-entry/${formData.opentag_id}`;
        method = "PUT";
        isUpdating = true;
      }


      const response = await axios({
        method: method,
        url: apiURL,
        data: payload,
        headers: { "Content-Type": "application/json" },
      });

      alert(
        isUpdating ? "Stock updated successfully!" : "Stock added successfully!"
      );
      await fetchData(); // Refresh data
      await fetchTagData(); // Refresh table inside modal

      setIsEditMode(false); // Exit edit mode

      if (isGeneratePDFRef.current) {
        generateAndDownloadPDF(payload);
      }

      localStorage.removeItem("tagStoneDetails");
      localStorage.removeItem("tagPurStoneDetails");

      setStoneList([]);
      setPurchaseStoneList([]);

      if (isUpdating) {
        // **Reset FormData completely after update**
        setTimeout(() => {
          setFormData((prevData) => ({
            PCode_BarCode: "",
            suffix: "",
            tag_id: selectedProduct?.tag_id || "",
            product_id: selectedProduct?.product_id || "",
            category: selectedProduct?.category || "",
            Pricing: selectedProduct?.Pricing || "",
            metal_type: selectedProduct?.metal_type || "",
            account_name: selectedProduct?.account_name || "",
            invoice: selectedProduct?.invoice || "",
            Gross_Weight: "",
            Stones_Weight: "",
            Stones_Price: "",
            deduct_st_Wt: "Yes",
            Weight_BW: "",
            Wastage_On: "Gross Weight",
            WastageWeight: "",
            // sub_category: prevData.sub_category,
            Purity: "",
            printing_purity: "",
            pur_Purity: "",
            HUID_No: prevData.HUID_No,
            Stock_Point: prevData.Stock_Point,
            design_master: prevData.design_master,
            Making_Charges_On: prevData.Making_Charges_On,
            pur_Making_Charges_On: prevData.pur_Making_Charges_On,
            MC_Per_Gram_Label: prevData.MC_Per_Gram_Label,
            pur_MC_Per_Gram_Label: prevData.MC_Per_Gram_Label,
            Status: "Available",
            Source: "Purchase",
            pur_Gross_Weight: "",
            pur_Stones_Weight: "",
            pur_Stones_Price: "",
            pur_deduct_st_Wt: "Yes",
            pur_Weight_BW: "",
            pur_WastageWeight: "",
            pur_Wastage_On: "Gross Weight",
            pcs: "1",
            pieace_cost: "",
            mrp_price: "",
            mrp_per_pcs: "",
            total_pcs_cost: "",
            MP_Per_Gram:"",
          }));
          setImage(null);
          fetchTagData();
        }, 100); // Small delay ensures React updates state correctly
      } else {
        // **Handle nextPCodeBarCode fetch for new entries**
        try {
          const response = await axios.get(`${baseURL}/getNextPCodeBarCode`, {
            params: { prefix: formData.item_prefix },
          });
          const nextPCodeBarCode = response.data.nextPCodeBarCode;

          setFormData((prevData) => ({
            ...prevData, // Keep previous values
            PCode_BarCode: nextPCodeBarCode,
            suffix: nextPCodeBarCode.replace(formData.item_prefix, ""),
            tag_id: selectedProduct?.tag_id || "",
            product_id: selectedProduct?.product_id || "",
            category: selectedProduct?.category || "",
            Pricing: selectedProduct?.Pricing || "",
            metal_type: selectedProduct?.metal_type || "",
            Gross_Weight: "",
            Stones_Weight: "",
            Stones_Price: "",
            deduct_st_Wt: "Yes",
            Weight_BW: "",
            Wastage_On: "Gross Weight",
            WastageWeight: "",
            Making_Charges_On: prevData.Making_Charges_On,
            pur_Making_Charges_On: prevData.pur_Making_Charges_On,
            MC_Per_Gram_Label: prevData.MC_Per_Gram_Label,
            pur_MC_Per_Gram_Label: prevData.MC_Per_Gram_Label,
            Status: "Available",
            Source: "Purchase",
            pur_Gross_Weight: "",
            pur_Stones_Weight: "",
            pur_Stones_Price: "",
            pur_deduct_st_Wt: "Yes",
            pur_Weight_BW: "",
            pur_WastageWeight: "",
            pur_Wastage_On: "Gross Weight",
            pcs: "1",
            pieace_cost: "",
            mrp_price: "",
            mrp_per_pcs: "",
            total_pcs_cost: "",
          }));
          setImage(null);
          fetchTagData();
        } catch (error) {
          console.error("Error fetching PCode_BarCode:", error);
        }
      }

      setIsGeneratePDF(true);
    } catch (error) {
      console.error(error);
      alert("An error occurred. Please try again.");
    } finally {
      setSaveLoader(false);
    }
  };

  const generateAndDownloadPDF = async (data) => {
    const doc = new jsPDF();
    let qrContent = "";

    if (data.Pricing === "By Weight") {
      qrContent = `PCode: ${data.PCode_BarCode}, Name: ${data.sub_category}, Weight: ${data.Gross_Weight}, Tag Weight: ${data.tag_weight}, Total Weight AW: ${data.TotalWeight_AW}, Making Charges: ${data.Making_Charges}`;
    } else if (data.Pricing === "By fixed") {
      qrContent = `PCode: ${data.PCode_BarCode}, Name: ${data.sub_category}, Piece Cost: ${data.pieace_cost}`;
    }

    try {
      const qrImageData = await QRCode.toDataURL(qrContent);

      doc.setFontSize(10); // Set a smaller font size
      doc.text("Product QR Code", 10, 10);
      doc.addImage(qrImageData, "PNG", 10, 15, 30, 30); // Smaller QR code

      doc.setFontSize(8); // Reduce font size for text content
      doc.text(`PCode: ${data.PCode_BarCode}`, 50, 20);
      doc.text(`Name: ${data.sub_category}`, 50, 25);

      if (data.Pricing === "By Weight") {
        doc.text(`Weight: ${data.Gross_Weight}`, 50, 30);
        doc.text(`Tag Weight: ${data.tag_weight}`, 50, 35);
        doc.text(`Total Weight: ${data.TotalWeight_AW}`, 50, 40);
        doc.text(`Making Charges: ${data.Making_Charges}`, 50, 45);
      } else if (data.Pricing === "By fixed") {
        doc.text(`Piece Cost: ${data.pieace_cost}`, 50, 30);
      }

      doc.save(`QR_Code_${data.PCode_BarCode}.pdf`);
    } catch (error) {
      console.error("Error generating QR Code PDF:", error);
    }
  };

  useEffect(() => {
    const getLastPcode = async () => {
      try {
        const response = await axios.get(`${baseURL}/last-pbarcode`);
        const suffix = response.data.lastPCode_BarCode || "001"; // Fallback to "001" if no value is fetched
        setFormData((prev) => ({
          ...prev,
          suffix, // Store the fetched suffix
          PCode_BarCode: `${prev.item_prefix || ""}${suffix}`, // Combine prefix with fetched suffix
        }));
      } catch (error) {
        console.error("Error fetching last PCode_BarCode:", error);
      }
    };

    getLastPcode();
  }, []);

  const [newSubCategory, setNewSubCategory] = useState({
    name: "",
    prefix: "",
    category: "",
    purity: "",
    selling_purity: "",
    printing_purity: "",
  });

  const handleModalChange = (e) => {
    let { name, value } = e.target;

    // Capitalize all letters if the field is "name" or "prefix"
    if (name === "name" || name === "prefix") {
      value = value.toUpperCase();
    }

    setNewSubCategory((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "prefix") {
      setFormData((prev) => ({
        ...prev,
        Prefix: value,
      }));
    }
  };

  useEffect(() => {
    if (selectedProduct) {
    }
  }, [selectedProduct]);

  const handleAddSubCategory = async () => {
    if (
      !newSubCategory.name ||
      !newSubCategory.prefix ||
      !newSubCategory.purity ||
      !newSubCategory.selling_purity ||
      !newSubCategory.printing_purity
    ) {
      alert("All fields are required.");
      return;
    }
    try {
      const data = {
        category_id: selectedProduct.product_id,
        subcategory_id: 1, // Assuming this is a static value or comes from somewhere else
        sub_category_name: newSubCategory.name,
        category: newSubCategory.category || formData.category,
        prefix: newSubCategory.prefix,
        metal_type: selectedProduct.metal_type,
        purity: newSubCategory.purity,
        selling_purity: newSubCategory.selling_purity,
        printing_purity: newSubCategory.printing_purity,
      };

      // Make POST request to the API
      const response = await axios.post(`${baseURL}/post/subcategory`, data);

      if (response.status === 201) {
        // Use 201 instead of 200 for created status
        alert("Subcategory added successfully");

        // Close modal and clear form
        handleCloseModal();
        setNewSubCategory({
          name: "",
          prefix: "",
          category: "",
          purity: "",
          selling_purity: "",
          printing_purity: "",
        });

        // Refresh subcategories and auto-select the new one
        await fetchSubCategories(); // Ensure categories are updated first

        // Find the newly added subcategory
        const updatedSubCategories = await axios.get(
          `${baseURL}/get/subcategories`
        );
        const filteredSubCategories = updatedSubCategories.data.filter(
          (subCategory) =>
            subCategory.category_id === selectedProduct.product_id
        );

        const addedSubCategory = filteredSubCategories.find(
          (sub) => sub.sub_category_name === newSubCategory.name
        );

        if (addedSubCategory) {
          // Fetch next PCode_BarCode
          const response = await axios.get(`${baseURL}/getNextPCodeBarCode`, {
            params: { prefix: addedSubCategory.prefix },
          });

          const nextPCodeBarCode = response.data.nextPCodeBarCode;

          // Auto-select the new subcategory and update form data
          setFormData((prevData) => ({
            ...prevData,
            sub_category: addedSubCategory.sub_category_name,
            subcategory_id: addedSubCategory.subcategory_id,
            item_prefix: addedSubCategory.prefix,
            Prefix: addedSubCategory.prefix,
            PCode_BarCode: nextPCodeBarCode,
            suffix: nextPCodeBarCode.replace(addedSubCategory.prefix, ""),
            // Purity: addedSubCategory.purity,
            Purity: addedSubCategory.selling_purity,
            pur_Purity: addedSubCategory.purity,
            printing_purity: addedSubCategory.printing_purity,
          }));
        }
      } else {
        console.error("Error adding subcategory:", response);
      }
    } catch (error) {
      console.error("Error during API request:", error);
    }
  };

  const fetchSubCategories = async () => {
    try {
      const response = await axios.get(`${baseURL}/get/subcategories`);
      
      // Normalize the pricing value from formData to match API response
      let normalizedPricing = formData.Pricing || "By Weight";
      if (normalizedPricing === "By Running Tag") {
        normalizedPricing = "By running tag";
      }
      
      // Filter by category AND pricing
      const filteredSubCategories = response.data.filter((subCategory) => {
        const matchesCategory = subCategory.category === selectedProduct.category;
        
        // Check pricing field (case-insensitive comparison)
        const subCategoryPricing = subCategory.pricing || subCategory.Pricing || "";
        const matchesPricing = subCategoryPricing.toLowerCase() === normalizedPricing.toLowerCase();
        
        return matchesCategory && matchesPricing;
      });
      
      setSubCategories(filteredSubCategories);
      return filteredSubCategories;
    } catch (error) {
      console.error("Error fetching subcategories:", error);
      return [];
    }
  }; //

  // const fetchSubCategories = async () => {
  //     try {
  //         const response = await axios.get(`${baseURL}/get/subcategories`);

  //         // Convert selectedProduct.metal_type to lowercase for case-insensitive comparison
  //         const selectedMetalType = selectedProduct.metal_type?.toLowerCase();

  //         // Apply filtering logic based on metal_type
  //         const filteredSubCategories = response.data.filter((subCategory) => {
  //             const subCategoryMetalType = subCategory.metal_type?.toLowerCase();
  //             if (selectedMetalType === "gold" || selectedMetalType === "diamond") {
  //                 return subCategoryMetalType === "gold";
  //             } else if (selectedMetalType === "silver") {
  //                 return subCategoryMetalType === "silver";
  //             }
  //             return false; // If none of the conditions match, return false
  //         });

  //         setSubCategories(filteredSubCategories);
  //     } catch (error) {
  //         console.error("Error fetching subcategories:", error);
  //     }
  // };

  useEffect(() => {
    if (selectedProduct?.product_id) {
      fetchSubCategories();
    }
  }, [selectedProduct, formData.Pricing]);

  // When editing "By Running Tag", ensure purity is recalculated after formData and subCategories are set
  useEffect(() => {
    if (isEditMode && formData.Pricing === "By Running Tag" && formData.sub_category) {
      // Small delay to ensure all formData is set before recalculating
      const timer = setTimeout(() => {
        // Force recalculation by ensuring Purity is empty
        // The displaySellingPurity useMemo will recalculate it from components
        if (formData.Purity && formData.Purity !== "" && formData.Purity !== "Manual") {
          setFormData((prev) => ({
            ...prev,
            Purity: "", // Clear to force recalculation
          }));
        }
      }, 100);
      
      return () => clearTimeout(timer);
    }
  }, [isEditMode, formData.Pricing, formData.sub_category, formData.pur_purityPercentage, formData.pur_Wastage_Percentage, formData.pur_MC_Per_Gram, formData.selling_addon_purity]);

  const [designOptions, setdesignOptions] = useState([]);

  const fetchDesignMaster = async () => {
    try {
      const response = await axios.get(`${baseURL}/designmaster`);
      const designMasters = response.data.map((item) => {

        return {
          value: item.design_name,
          label: item.design_name,
          id: item.design_id,
        };
      });
      setdesignOptions(designMasters);
    } catch (error) {
      console.error("Error fetching design masters:", error);
    }
  };

  useEffect(() => {
    fetchDesignMaster();
  }, []);

  const [pcs, setPcs] = useState(null);
  const [grossWeight, setGrossWeight] = useState(null);

  const fetchData = async () => {
    if (!selectedProduct.product_id || !selectedProduct.tag_id) return;

    try {
      const response = await fetch(
        `${baseURL}/entry/${selectedProduct.product_id}/${selectedProduct.tag_id}`
      );
      if (!response.ok) {
        throw new Error("Entry not found or server error");
      }
      const data = await response.json();
      setPcs(data.bal_pcs);
      setGrossWeight(formatToThreeDecimals(data.bal_gross_weight));
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [selectedProduct.product_id, selectedProduct.tag_id]); // Re-run when either changes

  // useEffect(() => {
  //     const fetchPurity = async () => {
  //         try {
  //             const response = await axios.get(`${baseURL}/purity`);
  //             const filteredPurity = response.data.filter(
  //                 (item) =>
  //                     item.metal.toLowerCase() === formData.metal_type.toLowerCase() ||
  //                     (["diamond", "others"].includes(formData.metal_type.toLowerCase()) && item.metal.toLowerCase() === "gold")
  //             );

  //             setPurityOptions(filteredPurity);

  //             console.log("Purity Options:", filteredPurity);

  //             let defaultOption = null;

  //             if (["gold", "diamond", "others"].includes(formData.metal_type.toLowerCase())) {
  //                 defaultOption = filteredPurity.find((option) =>
  //                     option.name.toLowerCase().includes("22")
  //                 );
  //             } else if (formData.metal_type.toLowerCase() === "silver") {
  //                 defaultOption = filteredPurity.find((option) =>
  //                     option.name.toLowerCase().includes("92.5")
  //                 );
  //             }

  //             if (defaultOption) {
  //                 const defaultPurityValue = `${defaultOption.name} | ${defaultOption.purity}`;
  //                 console.log("Setting default purity:", defaultPurityValue);

  //                 setFormData((prevFormData) => ({
  //                     ...prevFormData,
  //                     Purity: defaultPurityValue,
  //                     pur_Purity: defaultPurityValue, // Ensure exact match
  //                 }));
  //             }
  //         } catch (error) {
  //             console.error("Error fetching data:", error);
  //         }
  //     };

  //     if (formData.metal_type) {
  //         fetchPurity();
  //     }
  // }, [formData.metal_type]);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchTagData = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${baseURL}/get/opening-tags-entry`);
      const jsonData = await response.json();


      if (jsonData.result && Array.isArray(jsonData.result)) {
        // Filter data based on selectedProduct conditions
        const filteredData = jsonData.result.filter(
          (item) =>
            item.invoice === selectedProduct.invoice &&
            item.category === selectedProduct.category
        );

        setData(filteredData);
      } else {
        console.error("Unexpected API response format:", jsonData);
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchTagData();
  }, [selectedProduct]);

  const handleEdit = async (rowData) => {
    setIsEditMode(true);
    setImage(rowData.image || "");

    // For "By Running Tag", fetch subcategory data first to ensure we have selling addon values
    if (rowData.Pricing === "By Running Tag" && rowData.sub_category) {
      try {
        // Fetch subcategory details to ensure we have selling addon values
        const subcategoryResponse = await axios.get(`${baseURL}/get/subcategories`);
        const subcategoryData = subcategoryResponse.data.find(
          (sub) => sub.sub_category_name === rowData.sub_category
        );
        
        // Also refresh subCategories state to ensure calculateDisplaySellingPurity has access to it
        const normalizedPricing = "By running tag";
        const filteredSubCategories = subcategoryResponse.data.filter((subCategory) => {
          const matchesCategory = subCategory.category === rowData.category;
          const subCategoryPricing = subCategory.pricing || subCategory.Pricing || "";
          const matchesPricing = subCategoryPricing.toLowerCase() === normalizedPricing.toLowerCase();
          return matchesCategory && matchesPricing;
        });
        setSubCategories(filteredSubCategories);
        
        // Prepare edited data with subcategory selling addon values
        const editedData = { ...rowData };
        
        // Clear Purity so it gets recalculated from components
        editedData.Purity = "";
        
        // For "By Running Tag", purchase values should come from the purchase record (selectedProduct), not from tag entry
        // Get purchase purity from selectedProduct (purchase record)
        // Check if it's "Manual" first, then use purityPercentage
        let purchasePurityValue = "";
        if (selectedProduct?.Purity && String(selectedProduct.Purity).toLowerCase().includes("manual")) {
          purchasePurityValue = selectedProduct?.purityPercentage || "";
        } else {
          purchasePurityValue = selectedProduct?.Purity || selectedProduct?.purityPercentage || "";
        }
        
        // Get purchase wastage from selectedProduct (purchase record)
        const purchaseWastageValue = selectedProduct?.wastage || "";
        
        // Get purchase MC from selectedProduct (purchase record) - only if MC On is "MC %"
        let purchaseMCValue = "";
        if (selectedProduct?.Making_Charges_On === "MC %") {
          purchaseMCValue = selectedProduct?.Making_Charges_Value || "";
        }
        
        // Set purchase values in editedData from purchase record (selectedProduct)
        editedData.pur_purityPercentage = purchasePurityValue || rowData.pur_purityPercentage || "";
        editedData.pur_Purity = selectedProduct?.Purity || rowData.pur_Purity || "";
        editedData.pur_Wastage_Percentage = purchaseWastageValue || rowData.pur_Wastage_Percentage || "";
        editedData.pur_MC_Per_Gram = purchaseMCValue || rowData.pur_MC_Per_Gram || "";
        editedData.pur_Making_Charges_On = selectedProduct?.Making_Charges_On || rowData.pur_Making_Charges_On || rowData.Making_Charges_On || "";
        
        // Ensure selling addon values are set from subcategory if missing
        if (subcategoryData) {
          editedData.selling_addon_purity = rowData.selling_addon_purity || subcategoryData.selling_addon_purity || "";
          editedData.selling_addon_mc_percent = rowData.selling_addon_mc_percent || subcategoryData.selling_addon_mc_percent || "";
          editedData.selling_addon_wastage_percent = rowData.selling_addon_wastage_percent || subcategoryData.selling_addon_wastage_percent || "";
        }
        
        setFormData(editedData);
      } catch (error) {
        console.error("Error fetching subcategory details for edit:", error);
        // Fallback: still set formData even if subcategory fetch fails
        const editedData = { ...rowData };
        if (rowData.Pricing === "By Running Tag") {
          editedData.Purity = "";
        }
        setFormData(editedData);
      }
    } else {
      // For non-running tag items, set formData normally
      setFormData(rowData);
    }

    // Check Making_Charges_On value and set MC_Per_Gram_Label accordingly
    if (rowData.Making_Charges_On === "MC %") {
      setFormData((prevData) => ({
        ...prevData,
        MC_Per_Gram_Label: "MC%",
      }));
    } else if (
      rowData.Making_Charges_On === "MC / Gram" ||
      rowData.Making_Charges_On === "MC / Piece"
    ) {
      setFormData((prevData) => ({
        ...prevData,
        MC_Per_Gram_Label: "MC/Gm",
      }));
    }
  };

  const handleDelete = async (id) => {

    const url = `${baseURL}/delete/opening-tags-entry/${id}`;

    // Confirm before proceeding
    if (!window.confirm("Are you sure you want to delete this record?")) {
      return;
    }

    try {
      const response = await axios.delete(url);
      alert(response.data.message);

      // Fetch updated data after successful deletion
      fetchData();
      fetchTagData();
    } catch (error) {
      console.error(
        "Error deleting record:",
        error.response?.data || error.message
      );
      alert("Failed to delete record.");
    }
  };

  const exportToExcel = (event) => {
    event.preventDefault(); // Prevent form submission if inside a form

    if (data.length === 0) {
      alert("No data available to export.");
      return;
    }

    const worksheetData = data.map((item, index) => ({
      SI: index + 1,
      "Supplier Name": item.account_name,
      Barcode: item.PCode_BarCode,
      Category: item.category,
      "Sub Category": item.sub_category,
      "Design Name": item.design_master,
      Purity: item.Purity,
      Pcs: item.pcs,
      "Gross Wt": item.Gross_Weight,
      "Stone Wt": item.Stones_Weight,
      "Wt BW": item.Weight_BW,
      "W.Wt": item.WastageWeight,
      "Total Wt": item.TotalWeight_AW,
      "MC On": item.Making_Charges_On,
      "Total MC": item.Making_Charges,
      "Piece Cost": item.pieace_cost,
    }));

    const worksheet = XLSX.utils.json_to_sheet(worksheetData);

    // Auto-adjust column width
    const columnWidths = Object.keys(worksheetData[0]).map((key) => ({
      wch:
        Math.max(
          key.length,
          ...worksheetData.map((row) =>
            row[key] ? row[key].toString().length : 0
          )
        ) + 2,
    }));

    worksheet["!cols"] = columnWidths;

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    XLSX.writeFile(workbook, "TagDetails.xlsx");
  };

  const selectedCategory = subCategories.find(
    (category) => category.sub_category_name === formData.sub_category
  );

  return (
    <div style={{ paddingTop: "0px" }}>
      <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
        <h4 style={{ margin: "0" }}>Pieces: {pcs !== null ? pcs : "0"}</h4>
        <h4 style={{ margin: "0" }}>
          Gross Weight: {grossWeight !== null ? grossWeight : "0.000"}
        </h4>
      </div>
      <div className="container mb-4">
        <div className="row mt-1">
          <div className="col-12">
            <Form className="p-4 border rounded form-container-stockentry">
              <div className="stock-entry-form">
                <h4 className="mb-3" style={{ marginTop: "-16px" }}>
                  Stock Entry
                </h4>
                <Row className="stock-form-section">
                  {/* Always visible fields */}
                  <Col xs={12} md={2}>
                    <InputField
                      label="Supplier Name"
                      name="account_name"
                      value={formData.account_name}
                      onChange={handleChange}
                      readOnly
                    />
                  </Col>
                  {/* <Col xs={12} md={2}>
                                        <InputField
                                            label="Invoice"
                                            value={formData.invoice || ""} // Ensures no undefined issue
                                            onChange={(e) => {
                                                const input = e.target;
                                                const start = input.selectionStart; // Capture cursor position
                                                const transformedValue = input.value.toUpperCase();

                                                setFormData((prevState) => ({
                                                    ...prevState,
                                                    invoice: transformedValue,
                                                }));

                                                // Restore cursor position after transformation
                                                requestAnimationFrame(() => {
                                                    input.setSelectionRange(start, start);
                                                });
                                            }}
                                        />
                                    </Col> */}
                  <Col xs={12} md={2}>
                    <InputField
                      label="Category"
                      name="category"
                      value={formData.category}
                      onChange={handleChange}
                      readOnly
                    />
                  </Col>
                  <Col xs={12} md={3} className="d-flex align-items-center">
                    <div style={{ flex: 1 }}>
                      <InputField
                        label="Sub Category"
                        name="sub_category"
                        type="select"
                        value={formData.sub_category}
                        onChange={handleChange}
                        options={subCategories.map((category) => ({
                          value: category.sub_category_name,
                          label: category.sub_category_name,
                        }))}
                        autoFocus
                      />
                    </div>
                    <AiOutlinePlus
                      size={20}
                      color="black"
                      onClick={handleOpenModal}
                      style={{
                        marginLeft: "10px",
                        cursor: "pointer",
                        marginBottom: "20px",
                      }}
                    />
                  </Col>
                  <Col xs={12} md={3} className="d-flex align-items-center">
                    <div style={{ flex: 1 }}>
                      <InputField
                        label="Product Design Name"
                        name="design_master"
                        type="select"
                        value={formData.design_master}
                        onChange={handleChange}
                        options={designOptions.map((option) => ({
                          value: option.value,
                          label: option.label,
                        }))}
                      />
                    </div>
                    <AiOutlinePlus
                      size={20}
                      color="black"
                      onClick={handleOpenDesignModal} // Ensure this function is appropriate for handling this modal
                      style={{
                        marginLeft: "10px",
                        cursor: "pointer",
                        marginBottom: "20px",
                      }}
                    />
                  </Col>

                  <Col xs={12} md={2}>
                    <InputField
                      label="Pricing"
                      name="Pricing"
                      value={formData.Pricing}
                      onChange={handleChange}
                      readOnly
                    />
                  </Col>
                  {/* <Col xs={12} md={2}>
                                        <InputField
                                            label="Pricing"
                                            name="Pricing"
                                            type="select"
                                            value={formData.Pricing}
                                            onChange={handleChange}
                                            options={[
                                                { value: "By Weight", label: "By Weight" },
                                                { value: "By fixed", label: "By fixed" },
                                            ]}
                                        />
                                    </Col> */}
                  {isByFixed || isByRunningTag ? (
                    <>
                      <Col xs={12} md={2}>
                        <InputField
                          label="PCode/BarCode"
                          name="PCode_BarCode"
                          type="text"
                          value={formData.PCode_BarCode}
                          onChange={handleChange}
                        />
                      </Col>
                      <Col xs={12} md={2}>
                        <InputField
                          label="Printing Purity"
                          name="Purity"
                          value={formData.printing_purity} // Ensure correct value
                          onChange={handleChange}
                          readOnly
                          inputStyle={{
                            backgroundColor: "#f0f0f0",
                            color: "#777",
                            cursor: "not-allowed",
                          }}
                        />
                      </Col>
                      <Col xs={12} md={2}>
                        <InputField
                          label={isByFixed ? "Selling Rate" : "Selling Purity"}
                          name="Purity"
                          value={
                            (() => {
                              const breakdown = getSellingPurityBreakdown();
                              const purityValue = breakdown || displaySellingPurity || "";
                              const rateValue = formData.rate || (formData && formData.pieace_cost) || "";
                              
                              if (purityValue && rateValue) {
                                return `${purityValue} (${rateValue})`;
                              } else if (purityValue) {
                                return purityValue;
                              }else if (isByFixed && rateValue) {
                                return rateValue;
                              }
                              return "";
                            })()
                          }
                          onChange={handleChange}
                          readOnly
                          inputStyle={{
                            backgroundColor: "#f0f0f0",
                            color: "#777",
                            cursor: "not-allowed",
                          }}
                        />
                      </Col>
                      {isByRunningTag && (
                        <Col xs={12} md={2}>
                          <InputField
                            label="Purchase Purity"
                            name="pur_rate_cut"
                            value={
                              (() => {
                                const breakdown = getPurchasePurityBreakdown();
                                const rate = getPurchaseRate();
                                if (breakdown && rate) {
                                  return `${breakdown} (${rate})`;
                                } else if (breakdown) {
                                  return breakdown;
                                } else {
                                  const purity = displayPurchasePurity();
                                  if (purity && rate) {
                                    return `${purity} (${rate})`;
                                  } else if (purity) {
                                    return purity;
                                  } else if (rate) {
                                    return `(${rate})`;
                                  }
                                }
                                return "";
                              })()
                            }
                            readOnly
                            disabled
                            inputStyle={{
                              backgroundColor: "#f0f0f0",
                              color: "#777",
                              cursor: "not-allowed",
                            }}
                          />
                        </Col>
                      )}
                      <Col xs={12} md={2}>
                        <InputField
                          label="HUID No"
                          name="HUID_No"
                          value={formData.HUID_No}
                          onChange={handleChange}
                        />
                      </Col>
                      <Col xs={12} md={2}>
                        <InputField
                          label="Stock Point"
                          name="Stock_Point"
                          type="select"
                          value={formData.Stock_Point}
                          onChange={handleChange}
                          options={[
                            {
                              value: "Display Floor1",
                              label: "Display Floor1",
                            },
                            {
                              value: "Display Floor2",
                              label: "Display Floor2",
                            },
                            { value: "Strong room", label: "Strong room" },
                          ]}
                        />
                      </Col>
                    </>
                  ) : (
                    <>
                      <Col xs={12} md={2}>
                        <InputField
                          label="PCode/BarCode"
                          name="PCode_BarCode"
                          type="text"
                          value={formData.PCode_BarCode}
                          onChange={handleChange}
                        />
                      </Col>
                      <Col xs={12} md={2}>
                        <InputField
                          label="Printing Purity"
                          name="Purity"
                          // type="select"
                          value={formData.printing_purity} // Ensure correct value
                          onChange={handleChange}
                          readOnly
                          // options={[
                          //     { value: selectedCategory?.purity, label: selectedCategory?.purity }, // Show subcategory purity
                          //     ...purityOptions.map((option) => ({
                          //         value: `${option.name} | ${option.purity}`,
                          //         label: `${option.name} | ${option.purity}`,
                          //     })),
                          // ]}
                          // options={[
                          //     ...(formData.printing_purity
                          //         ? [{ value: selectedCategory?.printing_purity, label: selectedCategory?.printing_purity }]
                          //         : []),
                          //     ...purityOptions
                          //         .filter(option => option.name && option.purity) // Remove undefined values
                          //         .map(option => ({
                          //             value: `${option.name} | ${option.purity}`,
                          //             label: `${option.name} | ${option.purity}`,
                          //         })),
                          // ]}
                        />
                      </Col>
                      <Col xs={12} md={2}>
                        <InputField
                          label="HUID No"
                          name="HUID_No"
                          value={formData.HUID_No}
                          onChange={handleChange}
                        />
                      </Col>
                      <Col xs={12} md={2}>
                        <InputField
                          label="Stock Point"
                          name="Stock_Point"
                          type="select"
                          value={formData.Stock_Point}
                          onChange={handleChange}
                          options={[
                            {
                              value: "Display Floor1",
                              label: "Display Floor1",
                            },
                            {
                              value: "Display Floor2",
                              label: "Display Floor2",
                            },
                            { value: "Strong room", label: "Strong room" },
                          ]}
                        />
                      </Col>


                      <div className="purchase-form-left">
                        <Col className="tag-urd-form1-section">
                          <h4 className="mb-3" style={{ marginTop: "-10px" }}>
                            Sales
                          </h4>
                          {/* New Row for Weight Fields */}
                          <Row className="mt-3">
                            <Col xs={12} md={3}>
                              <InputField
                                label="Gross Wt"
                                name="Gross_Weight"
                                value={formData.Gross_Weight}
                                onChange={handleChange}
                              />
                            </Col>
                            <Col xs={12} md={3}>
                              <InputField
                                label="Stones Wt"
                                name="Stones_Weight"
                                value={formData.Stones_Weight}
                                onChange={handleChange}
                              />
                            </Col>
                            <Col xs={12} md="2">
                              <Button
                                variant="primary"
                                onClick={handleShow}
                                style={{
                                  backgroundColor: "#a36e29",
                                  borderColor: "#a36e29",
                                  fontSize: "0.8rem",
                                  marginLeft: "-20px",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                Stone Details
                              </Button>
                            </Col>
                            <Col xs={12} md={4}>
                              <InputField
                                label="Deduct St Wt"
                                name="deduct_st_Wt"
                                type="select"
                                value={formData.deduct_st_Wt || ""}
                                onChange={(e) =>
                                  handleChange("deduct_st_Wt", e.target.value)
                                }
                                options={[
                                  { value: "Yes", label: "Yes" },
                                  { value: "No", label: "No" },
                                ]}
                              />
                            </Col>
                            {/* <Col xs={12} md={4}>
                                                            <InputField
                                                                label="Stone Price/Carat"
                                                                name="stone_price_per_carat"
                                                                value={formData.stone_price_per_carat}
                                                                onChange={handleChange}
                                                            />
                                                        </Col> */}
                            <Col xs={12} md={3}>
                              <InputField
                                label="Stones Price"
                                name="Stones_Price"
                                value={formData.Stones_Price}
                                onChange={handleChange}
                              />
                            </Col>
                            <Col xs={12} md={3}>
                              <InputField
                                label="Selling Purity"
                                name="Purity"
                                // type="select"
                                value={
                                  (() => {
                                    const breakdown = getSellingPurityBreakdown();
                                    const purityValue = breakdown || displaySellingPurity || "";
                                    const rateValue = formData.rate || "";
                                    
                                    if (purityValue && rateValue) {
                                      return `${purityValue} (${rateValue})`;
                                    } else if (purityValue) {
                                      return purityValue;
                                    }
                                    return "";
                                  })()
                                }
                                onChange={handleChange}
                                readOnly
                                // options={[
                                //     { value: selectedCategory?.purity, label: selectedCategory?.purity }, // Show subcategory purity
                                //     ...purityOptions.map((option) => ({
                                //         value: `${option.name} | ${option.purity}`,
                                //         label: `${option.name} | ${option.purity}`,
                                //     })),
                                // ]}
                                // options={[
                                //     ...(formData.Purity
                                //         ? [{ value: selectedCategory?.selling_purity, label: selectedCategory?.selling_purity }]
                                //         : []),
                                //     ...purityOptions
                                //         .filter(option => option.name && option.purity) // Remove undefined values
                                //         .map(option => ({
                                //             value: `${option.name} | ${option.purity}`,
                                //             label: `${option.name} | ${option.purity}`,
                                //         })),
                                // ]}
                              />
                            </Col>
                            <Col xs={12} md={2}>
                              <InputField
                                label="Wt BW"
                                name="Weight_BW"
                                value={formData.Weight_BW}
                                onChange={handleChange}
                                readOnly
                              />
                            </Col>

                            <Col xs={12} md={4}>
                              <InputField
                                label="MC On"
                                name="Making_Charges_On"
                                type="select"
                                value={formData.Making_Charges_On}
                                onChange={handleChange}
                                options={[
                                  { value: "MC / Gram", label: "MC / Gram" },
                                  { value: "MC / Piece", label: "MC / Piece" },
                                  { value: "MC %", label: "MC %" },
                                ]}
                              />
                            </Col>

                            <Col xs={12} md={3}>
                              <InputField
                                label={formData.MC_Per_Gram_Label}
                                name="MC_Per_Gram"
                                value={formData.MC_Per_Gram}
                                onChange={handleChange}
                              />
                            </Col>

                            {/* Show Making_Charges field only when Making_Charges_On is "MC / Gram" or "MC / Piece" */}
                            {(formData.Making_Charges_On === "MC / Gram" ||
                              formData.Making_Charges_On === "MC / Piece") && (
                              <Col xs={12} md={2}>
                                <InputField
                                  label="MC"
                                  name="Making_Charges"
                                  value={formData.Making_Charges}
                                  onChange={handleChange}
                                />
                              </Col>
                            )}
                            <Col xs={12} md={4}>
                              <InputField
                                label="Wastage On"
                                name="Wastage_On"
                                type="select"
                                value={formData.Wastage_On}
                                onChange={handleChange}
                                options={[
                                  {
                                    value: "Gross Weight",
                                    label: "Gross Weight",
                                  },
                                  { value: "Weight BW", label: "Weight BW" },
                                ]}
                              />
                            </Col>
                            <Col xs={12} md={3}>
                              <InputField
                                label="Wastage %"
                                name="Wastage_Percentage"
                                value={formData.Wastage_Percentage}
                                onChange={handleChange}
                              />
                            </Col>
                            <Col xs={12} md={2}>
                              <InputField
                                label="W.Wt"
                                name="WastageWeight"
                                value={formData.WastageWeight}
                                onChange={handleChange}
                                readOnly
                              />
                            </Col>
                            <Col xs={12} md={3}>
                              <InputField
                                label="Total Wt"
                                name="TotalWeight_AW"
                                value={formData.TotalWeight_AW}
                                onChange={handleChange}
                                readOnly
                              />
                            </Col>
                            <Col xs={12} md={2}>
                              <InputField
                                label="Tag Wt"
                                name="tag_weight"
                                value={formData.tag_weight}
                                onChange={handleChange}
                              />
                            </Col>
                            <Col xs={12} md={2}>
                              <InputField
                                label="Size"
                                name="size"
                                value={formData.size}
                                onChange={handleChange}
                              />
                            </Col>
                            <Col xs={12} md={2}>
                              <InputField
                                label={formData.MC_Per_Gram_Label?.replace(/MC/g, "MP")}
                                name="MP_Per_Gram"
                                value={formData.MP_Per_Gram}
                                onChange={handleChange}
                              />
                            </Col>
                            <Col xs={12} md={3}>
                              <InputField
                                label="MP Amount"
                                name="MP_amount"
                                value={formData.MP_amount}
                                onChange={handleChange}
                              />
                            </Col>
                          </Row>
                        </Col>
                      </div>
                      <div className="purchase-form-right">
                        <Col className="tag-urd-form2-section">
                          <h4 className="mb-3" style={{ marginTop: "-10px" }}>
                            Purchase
                          </h4>
                          {/* New Row for Weight Fields */}
                          <Row className="mt-3">
                            <Col xs={12} md={3}>
                              <InputField
                                label="Gross Wt"
                                name="pur_Gross_Weight"
                                value={formData.pur_Gross_Weight}
                                onChange={handleChange}
                              />
                            </Col>
                            <Col xs={12} md={3}>
                              <InputField
                                label="Stones Wt"
                                name="pur_Stones_Weight"
                                value={formData.pur_Stones_Weight}
                                onChange={handleChange}
                              />
                            </Col>
                            <Col xs={12} md="2">
                              <Button
                                variant="primary"
                                onClick={handleShowPurchase}
                                style={{
                                  backgroundColor: "#a36e29",
                                  borderColor: "#a36e29",
                                  fontSize: "0.8rem",
                                  marginLeft: "-20px",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                Stone Details
                              </Button>
                            </Col>
                            <Col xs={12} md={4}>
                              <InputField
                                label="Deduct St Wt"
                                name="pur_deduct_st_Wt"
                                type="select"
                                value={formData.pur_deduct_st_Wt || ""}
                                onChange={(e) =>
                                  handleChange(
                                    "pur_deduct_st_Wt",
                                    e.target.value
                                  )
                                }
                                options={[
                                  { value: "Yes", label: "Yes" },
                                  { value: "No", label: "No" },
                                ]}
                              />
                            </Col>
                            {/* <Col xs={12} md={4}>
                                                            <InputField
                                                                label="Stone Price/Carat"
                                                                name="pur_stone_price_per_carat"
                                                                value={formData.pur_stone_price_per_carat}
                                                                onChange={handleChange}
                                                            />
                                                        </Col> */}
                            <Col xs={12} md={3}>
                              <InputField
                                label="Stones Price"
                                name="pur_Stones_Price"
                                value={formData.pur_Stones_Price}
                                onChange={handleChange}
                              />
                            </Col>
                            <Col xs={12} md={3}>
                              <InputField
                                label="Purity"
                                name="pur_Purity"
                                type="select"
                                value={formData.pur_Purity}
                                onChange={(e) =>
                                  handleChange("pur_Purity", e.target.value)
                                }
                                // options={[
                                //     ...purityOptions.map((option) => ({
                                //         value: `${option.name} | ${option.purity}`,
                                //         label: `${option.name} | ${option.purity}`,
                                //     })),
                                //     { value: "Manual", label: "Manual" } // Correct placement of Manual option
                                // ]}
                                // options={[
                                //   ...(formData.Purity
                                //     ? [
                                //         {
                                //           value:
                                //             selectedCategory?.purchase_purity,
                                //           label:
                                //             selectedCategory?.purchase_purity,
                                //         },
                                //       ]
                                //     : []),
                                //   ...purityOptions
                                //     .filter(
                                //       (option) => option.name && option.purity
                                //     ) // Remove undefined values
                                //     .map((option) => ({
                                //       value: `${option.name} | ${option.purity}`,
                                //       label: `${option.name} | ${option.purity}`,
                                //     })),
                                //   { value: "Manual", label: manualPurchasePurityLabel },
                                // ]}
                                options={[
                                  ...(formData.Purity
                                    ? [
                                        {
                                          value: selectedCategory?.purchase_purity,
                                          label: selectedCategory?.purchase_purity,
                                        },
                                      ]
                                    : []),

                                  // Add auto-selected existing purity like "40"
                                  ...(manualPurchasePurityValue
                                    ? [
                                        {
                                          value: `${manualPurchasePurityValue}`,
                                          label: `${manualPurchasePurityValue}`,
                                        },
                                      ]
                                    : []),

                                  // Existing purity options
                                  ...purityOptions
                                    .filter((o) => o.name && o.purity)
                                    .map((o) => ({
                                      value: `${o.name} | ${o.purity}`,
                                      label: `${o.name} | ${o.purity}`,
                                    })),

                                  // Manual option (fixed label)
                                  { value: "Manual", label: "Manual" },
                                ]}
                              />
                            </Col>
                            {formData.pur_Purity === "Manual" && (
                              <Col xs={12} md={4}>
                                <InputField
                                  label="Custom Purity %"
                                  // type="number"
                                  name="pur_purityPercentage"
                                  value={formData.pur_purityPercentage || ""}
                                  onChange={(e) =>
                                    handleChange(
                                      "pur_purityPercentage",
                                      e.target.value
                                    )
                                  }
                                />
                              </Col>
                            )}
                            <Col xs={12} md={2}>
                              <InputField
                                label="Wt BW"
                                name="pur_Weight_BW"
                                value={formData.pur_Weight_BW}
                                onChange={handleChange}
                                readOnly
                              />
                            </Col>

                            <Col xs={12} md={4}>
                              <InputField
                                label="MC On"
                                name="pur_Making_Charges_On"
                                type="select"
                                value={formData.pur_Making_Charges_On}
                                onChange={handleChange}
                                options={[
                                  { value: "MC / Gram", label: "MC / Gram" },
                                  { value: "MC / Piece", label: "MC / Piece" },
                                  { value: "MC %", label: "MC %" },
                                ]}
                              />
                            </Col>

                            <Col xs={12} md={3}>
                              <InputField
                                label={formData.MC_Per_Gram_Label}
                                name="pur_MC_Per_Gram"
                                value={formData.pur_MC_Per_Gram}
                                onChange={handleChange}
                              />
                            </Col>

                            {/* Show Making_Charges field only when Making_Charges_On is "MC / Gram" or "MC / Piece" */}
                            {(formData.pur_Making_Charges_On === "MC / Gram" ||
                              formData.pur_Making_Charges_On ===
                                "MC / Piece") && (
                              <Col xs={12} md={3}>
                                <InputField
                                  label="MC"
                                  name="pur_Making_Charges"
                                  value={formData.pur_Making_Charges}
                                  onChange={handleChange}
                                />
                              </Col>
                            )}

                            <Col xs={12} md={4}>
                              <InputField
                                label="Wastage On"
                                name="pur_Wastage_On"
                                type="select"
                                value={formData.pur_Wastage_On}
                                onChange={handleChange}
                                options={[
                                  {
                                    value: "Gross Weight",
                                    label: "Gross Weight",
                                  },
                                  { value: "Weight BW", label: "Weight BW" },
                                ]}
                              />
                            </Col>
                            <Col xs={12} md={3}>
                              <InputField
                                label="Wastage %"
                                name="pur_Wastage_Percentage"
                                value={formData.pur_Wastage_Percentage}
                                onChange={handleChange}
                              />
                            </Col>
                            <Col xs={12} md={2}>
                              <InputField
                                label="W.Wt"
                                name="pur_WastageWeight"
                                value={formData.pur_WastageWeight}
                                onChange={handleChange}
                                readOnly
                              />
                            </Col>
                            <Col xs={12} md={3}>
                              <InputField
                                label="Total Wt"
                                name="pur_TotalWeight_AW"
                                value={formData.pur_TotalWeight_AW}
                                onChange={handleChange}
                                readOnly
                              />
                            </Col>
                            <Col xs={12} md={3}>
                              <InputField
                                label="Purchase Purity"
                                value={
                                  (() => {
                                    const breakdown = getPurchasePurityBreakdown();
                                    const rate = getPurchaseRate();
                                    if (breakdown && rate) {
                                      return `${breakdown} (${rate})`;
                                    } else if (breakdown) {
                                      return breakdown;
                                    } else {
                                      const purity = displayPurchasePurity();
                                      if (purity && rate) {
                                        return `${purity} (${rate})`;
                                      } else if (purity) {
                                        return purity;
                                      } else if (rate) {
                                        return `(${rate})`;
                                      }
                                    }
                                    return "";
                                  })()
                                }
                                readOnly
                                disabled
                                inputStyle={{
                                  backgroundColor: "#f0f0f0",
                                  color: "#777",
                                  cursor: "not-allowed",
                                }}
                              />
                            </Col>
                          </Row>
                        </Col>
                      </div>
                    </>
                  )}

                  {formData.Pricing === "By fixed" && (
                    <>
                      <Col xs={12} md={1}>
                        <InputField
                          label="Pcs"
                          type="number"
                          value={formData.pcs}
                          onChange={(e) => handleChange("pcs", e.target.value)}
                        />
                      </Col>
                      <Col xs={12} md={2}>
                        <InputField
                          label="Piece Cost"
                          type="number"
                          value={formData.pieace_cost}
                          onChange={(e) =>
                            handleChange("pieace_cost", e.target.value)
                          }
                        />
                      </Col>
                      <Col xs={12} md={2}>
                        <InputField
                          label="Total Pcs Cost"
                          type="number"
                          value={formData.total_pcs_cost}
                          readOnly
                          inputStyle={{
                            backgroundColor: "#f0f0f0",
                            color: "#777",
                            cursor: "not-allowed",
                          }}
                        />
                      </Col>
                      <Col xs={12} md={1}>
                        <InputField
                          label="Tax %"
                          value={formData.tax_percent}
                          onChange={(e) =>
                            handleChange("tax_percent", e.target.value)
                          }
                          readOnly
                          inputStyle={{
                            backgroundColor: "#f0f0f0",
                            color: "#777",
                            cursor: "not-allowed",
                          }}
                        />
                      </Col>
                      <Col xs={12} md={2}>
                        <InputField
                          label="Total MRP"
                          type="number"
                          value={formData.mrp_price}
                          onChange={(e) =>
                            handleChange("mrp_price", e.target.value)
                          }
                        />
                      </Col>
                      <Col xs={12} md={1}>
                        <InputField
                          label="MRP / Pcs"
                          type="number"
                          value={formData.mrp_per_pcs}
                          onChange={(e) =>
                            handleChange("mrp_per_pcs", e.target.value)
                          }
                        />
                      </Col>
                      <Col xs={12} md={1}>
                        <InputField
                          label="MP/Pcs"
                          type="number"
                          value={formData.MP_Per_Gram}
                          onChange={(e) =>
                            handleChange("MP_Per_Gram", e.target.value)
                          }
                        />
                      </Col>
                      <Col xs={12} md={2}>
                        <InputField
                          label="MP Amount"
                          type="number"
                          value={formData.MP_amount}
                          onChange={(e) =>
                            handleChange("MP_amount", e.target.value)
                          }
                        />
                      </Col>
                    </>
                  )}
                  {formData.Pricing === "By Running Tag" && (
                    <>
                      <Col xs={12} md={1}>
                        <InputField
                          label="Pcs"
                          type="number"
                          value={formData.pcs}
                          onChange={(e) => handleChange("pcs", e.target.value)}
                        />
                      </Col>
                      <Col xs={6} md={2}>
                        <InputField
                          label="Gross Weight"
                          type="number"
                          step="0.001"
                          value={formData.Gross_Weight}
                          onChange={(e) =>
                            handleChange("Gross_Weight", e.target.value)
                          }
                        />
                      </Col>
                      <Col xs={12} md={2}>
                        <InputField
                          label="Piece Cost"
                          type="number"
                          value={formData.pieace_cost}
                          onChange={(e) =>
                            handleChange("pieace_cost", e.target.value)
                          }
                        />
                      </Col>
                      <Col xs={12} md={2}>
                        <InputField
                          label="Total Pcs Cost"
                          type="number"
                          value={formData.total_pcs_cost}
                          readOnly
                          inputStyle={{
                            backgroundColor: "#f0f0f0",
                            color: "#777",
                            cursor: "not-allowed",
                          }}
                        />
                      </Col>
                      <Col xs={12} md={1}>
                        <InputField
                          label="Tax %"
                          value={formData.tax_percent}
                          onChange={(e) =>
                            handleChange("tax_percent", e.target.value)
                          }
                          readOnly
                          inputStyle={{
                            backgroundColor: "#f0f0f0",
                            color: "#777",
                            cursor: "not-allowed",
                          }}
                        />
                      </Col>
                      <Col xs={12} md={2}>
                        <InputField
                          label="MRP / Pcs"
                          type="number"
                          value={formData.mrp_per_pcs}
                          readOnly
                          inputStyle={{
                            backgroundColor: "#f0f0f0",
                            color: "#777",
                            cursor: "not-allowed",
                          }}
                        />
                      </Col>
                      <Col xs={12} md={2}>
                        <InputField
                          label="Total MRP"
                          type="number"
                          value={formData.mrp_price}
                          readOnly
                          inputStyle={{
                            backgroundColor: "#f0f0f0",
                            color: "#777",
                            cursor: "not-allowed",
                          }}
                        />
                      </Col>
                    </>
                  )}
                </Row>
              </div>
              <div
                className="d-flex flex-wrap justify-content-between align-items-center"
                style={{ gap: "16px" }}
              >
                {/* <label>
                                    <input
                                        type="checkbox"
                                        checked={isGeneratePDF}
                                        onChange={(e) => setIsGeneratePDF(e.target.checked)}
                                    />
                                    Generate PDF
                                </label> */}
                <label className="checkbox-label" htmlFor="tcs">
                  <input
                    type="checkbox"
                    id="tcs"
                    name="tcsApplicable"
                    className="checkbox-input"
                    checked={isGeneratePDF}
                    onChange={(e) => setIsGeneratePDF(e.target.checked)}
                  />
                  Print QR Code
                </label>

                <div
                  className="d-flex flex-wrap align-items-center"
                  style={{ gap: "16px" }}
                >
                  <div className="image-upload-container">
                    <Dropdown>
                      <Dropdown.Toggle id="dropdown-basic-button">
                        Upload Image
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item onClick={() => fileInputRef.current.click()}>
                          Select Image
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => setIsCameraOpen(true)}>
                          Capture Image
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>

                    <input
                      type="file"
                      accept="image/*"
                      ref={fileInputRef}
                      onChange={handleImageChange}
                      style={{ display: "none" }}
                    />

                    {isCameraOpen && (
                      <div className="webcam-container mt-2">
                        <Webcam
                          audio={false}
                          ref={webcamRef}
                          screenshotFormat="image/jpeg"
                          className="img-thumbnail"
                        />
                        <div className="d-flex gap-2 mt-2">
                          <Button onClick={captureImage} variant="primary">
                            Capture
                          </Button>
                          <Button onClick={() => setIsCameraOpen(false)} variant="danger">
                            Cancel
                          </Button>
                        </div>
                      </div>
                    )}

                    {image && (
                      <div
                        style={{
                          position: "relative",
                          display: "inline-block",
                          marginTop: "10px",
                        }}
                      >
                        <img
                          src={image}
                          alt="Selected"
                          style={{
                            width: "100px",
                            height: "100px",
                            borderRadius: "8px",
                          }}
                        />
                        <button
                          type="button"
                          onClick={clearImage}
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                            background: "transparent",
                            border: "none",
                            color: "red",
                            fontSize: "16px",
                            cursor: "pointer",
                            zIndex: 10,
                          }}
                        >
                          <FaTrash />
                        </button>
                      </div>
                    )}
                  </div>

                  <div className="text-end">
                    <Button
                      variant="secondary"
                      onClick={handleCloseTagModal}
                      style={{ backgroundColor: "gray", marginRight: "10px" }}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      variant="success"
                      style={{
                        backgroundColor: "#a36e29",
                        borderColor: "#a36e29",
                      }}
                      onClick={handleSubmit}
                    >
                      {saveLoader ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        </>
                      ) : isEditMode ? (
                        "Update"
                      ) : (
                        "Save"
                      )}
                    </Button>
                  </div>
                </div>
              </div>

              {/* <OpeningTagsTable /> */}
              <div
                className="container mt-2"
                style={{ overflowX: "auto", maxWidth: "100%" }}
              >
                {/* Excel Export Button */}
                <button
                  onClick={exportToExcel}
                  style={{
                    marginBottom: "10px",
                    padding: "5px 5px",
                    backgroundColor: "green",
                    color: "white",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <FaFileExcel style={{ marginRight: "5px" }} /> Export to Excel
                </button>
                <Table
                  bordered
                  style={{ whiteSpace: "nowrap", fontSize: "15px" }}
                >
                  <thead style={{ fontSize: "14px", fontWeight: "bold" }}>
                    <tr>
                      <th>SI</th>
                      <th>Barcode</th>
                      <th>Category</th>
                      <th>Sub Category</th>
                      <th>Design Name</th>
                      <th>Gross Wt</th>
                      <th>Stone Wt</th>
                      <th>Wt BW</th>
                      <th>W.Wt</th>
                      <th>{formData.MC_Per_Gram_Label || "MC"}</th>{" "}
                      {/* Dynamically Updated */}
                      <th>Total Wt</th>
                      <th>Image</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody style={{ fontSize: "14px" }}>
                    {data.length > 0 ? (
                      data.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.PCode_BarCode}</td>
                          <td>{item.category}</td>
                          <td>{item.sub_category}</td>
                          <td>{item.design_master}</td>
                          <td>{item.Gross_Weight}</td>
                          <td>{item.Stones_Weight}</td>
                          <td>{item.Weight_BW}</td>
                          <td>{item.WastageWeight}</td>
                          <td>{item.MC_Per_Gram}</td>{" "}
                          {/* MC column remains unchanged */}
                          <td>{item.TotalWeight_AW}</td>
                          <td>
                            {item.image ? (
                              <img
                                src={item.image}
                                alt="Product"
                                style={{
                                  width: "50px",
                                  height: "50px",
                                  objectFit: "cover",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  const newWindow = window.open();
                                  newWindow.document.write(
                                    `<img src="${item.image}" alt="Product" style="width: 100%; height: auto;" />`
                                  );
                                }}
                                onError={(e) =>
                                  (e.target.src = "/placeholder.png")
                                }
                              />
                            ) : (
                              "No Image"
                            )}
                          </td>
                      <td>
                            <FaEye
                              style={{
                                cursor: "pointer",
                                color: "green",
                                marginRight: "10px",
                              }}
                              onClick={() => handleView(item)}
                            />
                            <FaEdit
                              style={{ cursor: "pointer", color: "blue" }}
                              onClick={() => handleEdit(item)}
                            />
                          {(() => {
                            const status = String(item.Status || "").toLowerCase();
                            const soldStatuses = ["sold", "sale returned", "reserved"];
                            const pcsValue = Number(item.pcs);
                            const remPcsValue = Number(item.rem_pcs);
                            const isPartiallySold =
                              Number.isFinite(pcsValue) &&
                              pcsValue > 0 &&
                              Number.isFinite(remPcsValue) &&
                              remPcsValue < pcsValue;
                            const isTagUsed =
                              soldStatuses.includes(status) || isPartiallySold;

                            const handleTagDeleteClick = () => {
                              if (isTagUsed) {
                                alert(
                                  "This tag cannot be deleted because it has already been used in sales."
                                );
                                return;
                              }
                              handleDelete(item.opentag_id);
                            };

                            return (
                              <FaTrash
                                style={{
                                  cursor: isTagUsed ? "not-allowed" : "pointer",
                                  marginLeft: "10px",
                                  color: isTagUsed ? "gray" : "red",
                                  opacity: isTagUsed ? 0.5 : 1,
                                }}
                                onClick={handleTagDeleteClick}
                                title={
                                  isTagUsed
                                    ? "Cannot delete: Tag already used in sales"
                                    : "Delete tag entry"
                                }
                              />
                            );
                          })()}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="12" className="text-center">
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </Form>
          </div>
        </div>
      </div>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Add New Sub Category</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="categoryName">
              <Form.Label>Category</Form.Label>
              <Form.Control
                type="text"
                name="category"
                value={newSubCategory.category || formData.category}
                onChange={handleModalChange}
                placeholder="Enter category"
                readOnly
              />
            </Form.Group>
            <Form.Group controlId="subCategoryName">
              <Form.Label>Sub Category Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={newSubCategory.name}
                onChange={handleModalChange}
              />
            </Form.Group>

            <Row>
              <Col>
                <Form.Group controlId="subCategoryPrefix">
                  <Form.Label>Prefix</Form.Label>
                  <Form.Control
                    type="text"
                    name="prefix"
                    value={newSubCategory.prefix}
                    onChange={handleModalChange}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group controlId="subCategoryPrintingPurity">
                  <Form.Label>Printing Purity</Form.Label>
                  <Form.Control
                    type="text"
                    name="printing_purity"
                    value={newSubCategory.printing_purity}
                    onChange={handleModalChange}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col>
                <Form.Group controlId="subCategorySellingPurity">
                  <Form.Label>Selling Purity</Form.Label>
                  <Form.Control
                    type="number"
                    name="selling_purity"
                    value={newSubCategory.selling_purity}
                    onChange={handleModalChange}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group controlId="subCategoryPurity">
                  <Form.Label>Purchase Purity</Form.Label>
                  <Form.Control
                    type="text"
                    name="purity"
                    value={newSubCategory.purity}
                    onChange={handleModalChange}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          <Button variant="primary" onClick={handleAddSubCategory}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showDesignModal} onHide={handleCloseDesignModal}>
        <Modal.Header closeButton>
          <Modal.Title>Add New Product Design Name</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="designCategory">
              <Form.Label>Category</Form.Label>
              <Form.Control
                type="text"
                name="category"
                value={newDesign.category || formData.category}
                onChange={handleDesignModalChange}
                placeholder="Enter category"
                readOnly
              />
            </Form.Group>
            <Form.Group controlId="metalType">
              <Form.Label>Metal Type</Form.Label>
              <Form.Control
                type="text"
                name="metal"
                value={newDesign.metal || formData.metal_type}
                onChange={handleDesignModalChange}
                placeholder="Enter metal type"
                readOnly
              />
            </Form.Group>
            <Form.Group controlId="designName">
              <Form.Label>Product Design Name</Form.Label>
              <Form.Control
                type="text"
                name="design_name"
                value={newDesign.design_name}
                onChange={handleDesignModalChange}
                placeholder="Enter design name"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseDesignModal}>
            Close
          </Button>
          <Button variant="primary" onClick={handleAddDesign}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      <StoneDetailsModal
        show={show}
        handleClose={handleClose}
        stoneDetails={stoneDetails}
        setStoneDetails={setStoneDetails}
        handleAddStone={handleAddStone}
        stoneList={stoneList}
        handleEditStone={handleEditStone}
        handleDeleteStone={handleDeleteStone}
        editingStoneIndex={editingStoneIndex}
      />
      <PurchaseStoneDetailsModal
        showPurchase={showPurchase}
        handleClosePurchase={handleClosePurchase}
        purStoneDetails={purStoneDetails}
        setPurStoneDetails={setPurStoneDetails}
        handleAddTagPurStone={handleAddTagPurStone}
        purchaseStoneList={purchaseStoneList}
        handleTagPurEditStone={handleTagPurEditStone}
        handleTagPurDeleteStone={handleTagPurDeleteStone}
        editingPurchaseStoneIndex={editingPurchaseStoneIndex}
      />
      <Modal
        show={showViewModal}
        onHide={handleCloseViewModal}
        centered
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>View Product Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedRow ? (
            <Table
              className="dataTable_headerCell1"
              bordered
              hover
              responsive
              size="sm"
              style={{ backgroundColor: "#fff" }}
            >
              <tbody>
                {(() => {
                  // All possible fields with labels (42 total)
                  const fields = [
                    { key: "account_name", label: "Supplier" },
                    { key: "category", label: "Category" },
                    { key: "sub_category", label: "Sub Category" },
                    { key: "design_master", label: "Design Name" },
                    { key: "Pricing", label: "Pricing" },
                    { key: "PCode_BarCode", label: "Barcode" },
                    { key: "HUID_No", label: "HUID No" },
                    { key: "Stock_Point", label: "Stock Point" },
                    { key: "Gross_Weight", label: "Gross Weight" },
                    { key: "Stones_Weight", label: "Stone Weight" },
                    { key: "Wastage_Percentage", label: "Wastage %" },
                    { key: "TotalWeight_AW", label: "Total Weight" },
                    { key: "Making_Charges", label: "Making Charges" },
                    { key: "Status", label: "Status" },
                    { key: "Purity", label: "Purity" },
                    { key: "metal_type", label: "Metal Type" },
                    { key: "Wastage_On", label: "Wastage On" },
                    { key: "WastageWeight", label: "Wastage Weight" },
                    { key: "MC_Per_Gram", label: "MC Per Gram" },
                    { key: "Making_Charges_On", label: "Making Charges On" },
                    { key: "deduct_st_Wt", label: "Deduct Stone Wt" },
                    { key: "size", label: "Size" },
                    { key: "tag_id", label: "Tag ID" },
                    { key: "tag_weight", label: "Tag Weight" },
                    { key: "pur_Gross_Weight", label: "Pur. Gross Weight" },
                    { key: "pur_Stones_Weight", label: "Pur. Stone Weight" },
                    { key: "pur_deduct_st_Wt", label: "Pur. Deduct Stone Wt" },
                    { key: "pur_Stones_Price", label: "Pur. Stones Price" },
                    { key: "pur_Weight_BW", label: "Pur. Weight BW" },
                    { key: "pur_Wastage_On", label: "Pur. Wastage On" },
                    { key: "pur_Wastage_Percentage", label: "Pur. Wastage %" },
                    { key: "pur_WastageWeight", label: "Pur. Wastage Weight" },
                    { key: "pur_TotalWeight_AW", label: "Pur. Total Weight" },
                    { key: "pur_MC_Per_Gram", label: "Pur. MC / Gram" },
                    { key: "pur_Making_Charges", label: "Pur. MC Charges" },
                    {
                      key: "stone_price_per_carat",
                      label: "Stone Price / Carat",
                    },
                    { key: "pcs", label: "Pcs" },
                    { key: "pieace_cost", label: "Piece Cost" },
                    { key: "selling_price", label: "Selling Price" },
                    { key: "tax_percent", label: "Tax %" },
                    { key: "mrp_price", label: "MRP Price" },
                    { key: "total_pcs_cost", label: "Total Pcs Cost" },
                  ];

                  const validFields = fields;

                  // Divide into rows of 3 (key-value pairs)
                  const rows = [];
                  for (let i = 0; i < validFields.length; i += 3) {
                    rows.push(validFields.slice(i, i + 3));
                  }

                  return rows.map((rowFields, rowIndex) => (
                    <tr
                      key={rowIndex}
                      className="table-values-sales"
                      style={{
                        backgroundColor:
                          rowIndex % 2 === 0 ? "#f8f9fa" : "#fff",
                        borderBottom: "1px solid #e9ecef",
                      }}
                    >
                      {rowFields.map((field, colIndex) => (
                        <React.Fragment key={colIndex}>
                          {/* Label cell */}
                          <td
                            style={{
                              width: "16.66%",
                              padding: "6px 8px",
                              textAlign: "left",
                              borderRight: "1px solid #e9ecef",
                              borderBottom: "1px solid #e9ecef",
                              backgroundColor: "#f8f9fa",
                            }}
                          >
                            <strong
                              style={{
                                fontSize: "10px",
                                color: "#6B451E",
                                fontWeight: "600",
                              }}
                            >
                              {field.label}
                            </strong>
                          </td>

                          {/* Value cell */}
                          <td
                            style={{
                              width: "16.66%",
                              padding: "6px 8px",
                              textAlign: "left",
                              borderRight: "1px solid #e9ecef",
                              borderBottom: "1px solid #e9ecef",
                            }}
                          >
                            <span
                              style={{
                                fontSize: "11px",
                                color: "#495057",
                                fontWeight: "500",
                              }}
                            >
                              {selectedRow[field.key]}
                            </span>
                          </td>
                        </React.Fragment>
                      ))}

                      {/* Fill remaining columns if row incomplete */}
                      {rowFields.length < 3 &&
                        Array.from({ length: (3 - rowFields.length) * 2 }).map(
                          (_, emptyIndex) => (
                            <td
                              key={`empty-${emptyIndex}`}
                              style={{
                                width: "16.66%",
                                padding: "6px 8px",
                                borderRight: "1px solid #e9ecef",
                                borderBottom: "1px solid #e9ecef",
                                backgroundColor:
                                  emptyIndex % 2 === 0 ? "#f8f9fa" : "#fff",
                              }}
                            ></td>
                          )
                        )}
                    </tr>
                  ));
                })()}
              </tbody>
            </Table>
          ) : (
            <p>No data available.</p>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseViewModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default TagEntry;
